import React, { useEffect, useMemo, useState, useRef } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  CircularProgress,
  Grid,
  Box,
  Button,
  Typography,
  TextField,
  MenuItem,
  InputAdornment,
  Card,
  Dialog,
  DialogActions, DialogContent,  DialogContentText, DialogTitle, CardContent,
  Tabs, Tab,
  FormControlLabel,
  Checkbox,
  Paper, Chip
} from "@mui/material";
import { FaMoneyBillWave, FaPlusCircle ,FaFileAlt, FaClipboardList , FaChartPie , FaCog , FaMoneyCheckAlt, FaChartBar } from 'react-icons/fa'; // Example icons

import { useNotifier } from "../../Core/Notifier";
import { useStyles } from "../../theme/appStyles";
import { useNavigate } from "react-router-dom";
import { CiSearch } from "react-icons/ci";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import Pagination from "../../Components/Pagination";
import axios from "axios";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import DescriptionIcon from '@mui/icons-material/Description';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import CommentIcon from '@mui/icons-material/Comment';
import { Tooltip as MuiTooltip } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';  
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";
import LoopIcon from '@mui/icons-material/Loop';           // Circular arrow, used for Before
import LoopOutlinedIcon from '@mui/icons-material/LoopOutlined'; // Outlined circular arrow, used for After
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import {
  ICompanyDetails,
  IInvoice,
  ICustomer,
  ICategory,
  ISalesCategory,
  IProductPopUP,
  IModifierGroupPopUp,
  IModifierGroup,
  IModifier,
  IModifierPopUp,
  IVariantPopUP,
  ISerializedItem,
  IModifierGrpPopUp, 
  ISlotSelection,
} from "../../Api/Interface/api.interface";
import {
  useDeleteCustomerMutation,
  useGetAllInvoiceQuery,
  useGetCompanyQuery,
  useGetCustomerQuery,
  useGetWorkOrderQuery,
  useGetAllCategoryNameQuery,
  useGetCategoryQuery,
  useGetSalesCategoryQuery,
  useGetProductQuery,
  useCreateWorkOrderMutation,
  useGetLastWorkOrderIdQuery,
  useUpdateInvoiceStatusQuery,
  useCreateCustomerMutation,
  useGetVariantQuery,
  useGetAllMainCategoryQuery,
  useGetSubCategoryByArrayQuery,
    useGetModifierGrpQuery,
} from "../../Api/attoDeskApi";
import CustomCheckbox from "../../Components/Checkbox.tsx";
import { TransferType, WorkOrderStatus } from "../../Core/Enum/enum";
import useDebounce from "../../Components/SearchDebonce/useDebounce";
import ReactToPrint from "react-to-print";
import LocalPrintshopSharpIcon from "@mui/icons-material/LocalPrintshopSharp";
import moment from "moment";
import AddIcon from "@mui/icons-material/Add";
import AOS from 'aos';
import 'aos/dist/aos.css';
import MoneyIcon from '@mui/icons-material/Money';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import PaymentIcon from '@mui/icons-material/Payment';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import PercentIcon from '@mui/icons-material/Percent';
import CheckCircleOutlineSharpIcon from "@mui/icons-material/CheckCircleOutlineSharp";
import { useFormik } from "formik";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import {
  validateEmail,
  validatePhoneNumber,
} from "../../Components/Validation/validationUtils";
import { uploadImage } from "../../Components/UploadFile/upload";
import Autocomplete from '@mui/material/Autocomplete';
import { createFilterOptions } from '@mui/material/Autocomplete';
import Avatar from "@mui/material/Avatar";
import placeholderImage from '../../Images/fav.png';
import { serialize } from "v8";
import { cornersOfRectangle } from "@dnd-kit/core/dist/utilities/algorithms/helpers";
import GameSlotModal from "./Components/GameSlotPopUp";



ChartJS.register(ArcElement, Tooltip, Legend);

interface Expense {
  id: number;
  date: string;
  description: string;
  remarks: string;
  amount: number;
  hst: number;
  category: number;
  status: number;
  total: number;
  file?: string;
  created_at: string;
  before_images?: string;
  after_images?: string;
}

interface Category {
  id: number;
  category_name: string;
}

interface Driver {
  id: number;
  driverFirstName: string;
  driverLastName: string;
  driverUserRole: string;
}

interface Deposit {
  id: number;
  amount: string;
  user_id: number;
  created_at: string;
  date: string;
  is_approved: boolean; 
  remarks: string;
}

interface UserInfo {
  id: number;
  username: string;
  token: string;
  user_id: number;
}

// interface Payment {
//   id: number;
//   work_order_id: number;
//   amount: number;
//   payment_method: string;
//   created_at: string;
//   InvoiceNo: string;
// }

interface CartItem {
  id: number;
  productName: string;
  productPrice: number;
  quantity: number;
  salePrice: number;
  offerPrice?: number;
  variantName?: string;   
  variantPrice?: number;
   type?: 'product' | 'modifier' | 'variant';
   serializedItems?: ISerializedItem[]; 
   wp_page_id?: string;

   productCategoryId?:number;
    productConversionUnit?: number[];

  slotIds?: number[];   // for games
  slotTimes?: string[]; // optional: start-end times for display
  date?: string;   
}

interface InstantSaleForm {
  product_name: string;
  price: string;
  hst: boolean;
  description: string;
}

interface InstantSale {
  id: number;
  product_name: string;
  price: string;
  hst: boolean;
  description: string;
  created_at: string;
}

interface IDiscount {
  value: number | null;
  description: string;
}

type Payment = {
  method: string;
  amount: number;
};

interface Variant {
  id?: number;
  variantName: string;
  price: string;
  isActive: boolean;
}



const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [expenses, setExpenses] = useState<Expense[]>([]); 
  const [categories, setCategories] = useState<Category[]>([]); 
  const [team, setTeam] = useState<Driver[]>([]); 
  const [deposit, setDeposit] = useState<Deposit[]>([]); 
  const { showErrorMessage, showMessage } = useNotifier();
  const API_URL = process.env.REACT_APP_API_URL;
  const [searchQuery, setSearchQuery] = useState(""); 
  const [searchQueryCustomer, setSearchQueryCustomer] = useState(""); 
  const [page, setPage] = useState(0);
const [rowsPerPage, setRowsPerPage] = useState(50);
const LARAVEL_API_URL = process.env.REACT_APP_LARAVEL_API;
const [openModal, setOpenModal] = useState(false);
const [openModalView, setOpenModalView] = useState(false);
const [fileUrl, setFileUrl] = useState<string | null>(null);
const [userInfo, setUserInfo] = useState<UserInfo | null>(null);
const [tooltipOpen, setTooltipOpen] = React.useState<Record<number, boolean>>({});
const [showImages, setShowImages] = useState(false);
const [beforeImages, setBeforeImages] = useState<string[]>([]);
const [afterImages, setAfterImages] = useState<string[]>([]);
const isPdf = fileUrl?.endsWith('.pdf');
const [currentSearchQuery, setCurrentSearchQuery] = useState("");
const debouncedSearchQuery = useDebounce(searchQuery, 300);
const [totalInvoiceCount, setTotalInvoiceCount] = useState(0);
const [totalPayments, setTotalPayments] = useState(0);
const [totalClients, setTotalClients] = useState<number>(0);  
const componentRef = useRef<HTMLDivElement>(null);
// const [mainItems, setMainItems] = useState<MainItem[]>([]);
const [variantDetails, setVariantDetails] = useState<any[]>([]); // Items for selected category
const [loading, setLoading] = useState(false);
const [customers, setCustomers] = useState<ICustomer[]>([]); 
const [showInstantSaleForm, setShowInstantSaleForm] = useState(false);
const [showCashForm, setShowCashForm] = useState(false);
const [showCustomerForm, setShowCustomerForm] = useState(false);
const [showSplitForm, setShowSplitForm] = useState(false);
const [showDiscountForm, setShowDiscountForm] = useState(false);
const [instantSales, setInstantSales] = useState<InstantSale[]>([]);
const [walkIn, setWalkIn] = useState(false);
const [input, setInput] = useState("");
const [totalAmount, setTotalAmount] = useState(120.00); // Example total
const [amountPaid, setAmountPaid] = useState(0.00);
const [amtPaid, setAmtPaid] = useState(0.00);
const [change, setChange] = useState(0);
const [id, setId] = useState("");
const [poNumber, setPoNumber] = useState("");
const [selectedImage, setSelectedImage] = useState<File | undefined>(undefined);
const [isImageUploading, setIsImageUploading] = useState(false);
const [unitPrice, setUnitPrice] = useState<number>(0);
const [splitPayment, setSplitPayment] = useState(false);

const [grandTotalEithDiscount, setGrandTotalWithDiscount] =
    useState<number>(0);
const [selectedVariants, setSelectedVariants] = useState<Variant[]>([]);
const [showVariantDialog, setShowVariantDialog] = useState(false);
const [selectedModifierGroup, setSelectedModifierGroup] = React.useState<IModifierGroupPopUp | null>(null);
const [selectedVariantProduct, setSelectedVariantProduct] =  useState<IVariantPopUP[]>([])
const [showingVariants, setShowingVariants] = useState(false);
const [selectedSerialProducts, setSelectedSerialProducts] = useState<ISerializedItem[]>([]);
const [searchTextSerialized, setSearchTextSerialized] = useState("");
const [actionLoading, setActionLoading] = useState<null | "Cash" | "Credit" | "Debit">(null);


const [showSerialPopup, setShowSerialPopup] = useState(false);

const [selectedModifierId, setSelectedModifierId] = useState<number | null>(null);
const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(
    null
  );
  const [selectedSubCategoryId, setSelectedSubCategoryId] = useState<
    number | null
  >(null);

  const [selectedSubToSubCategoryId, setSelectedSubToSubCategoryId] = useState<
    number | null
  >(null);

  const [selectedSubToSubToSubCategoryId, setSelectedSubToSubToSubCategoryId] =
    useState<number | null>(null);
 

  const WALK_IN_CUSTOMER: ICustomer = {
  id: 0,
  customerFirstName: "Walk-in",
  customerLastName: "",
  customerMobileNum: "",
  customerEmail: "",
  customerProvince: "",
  customerCity: "",
  customerPostalCode: "",
  customerStreetName: "",
  customerStreetNumber: "",
  customerDescription: "",
  customerCompanyName: "",
  customerCompanyPhoneNumebr: "",
  customerCompanyEmail: "",
  customerPreferTimeToCall: "",
  customerImg: "",
};


const [instantSaleForm, setInstantSaleForm] = useState<InstantSaleForm>({
  product_name: '',
  price: '',
  hst: false,
  description: '',
});
const [newCustomer, { isLoading }] = useCreateCustomerMutation();

const { data, isLoading: customerIsLoading, isError, refetch } = useGetCustomerQuery({
    searchText: currentSearchQuery,
    id: "",
  });

  

    const productCategoryId = selectedSubToSubToSubCategoryId
    ? Number(selectedSubToSubToSubCategoryId)
    : selectedSubToSubCategoryId
    ? Number(selectedSubToSubCategoryId)
    : selectedSubCategoryId
    ? Number(selectedSubCategoryId)
    : selectedCategoryId
    ? Number(selectedCategoryId)
    : String("");


   const {
      data: productData,
      isLoading: productIsLoading,
      refetch: productRefetch,
    } = useGetProductQuery({
      productBrandId: null,
       productCategoryId: searchQuery ? null : String(productCategoryId), 
      productTagIds: null,
      productViewOnline: null,
      createdDateStart: null,
      createdDateEnd: null,
      searchText: currentSearchQuery,
      //searchText: "",
      createdDate: null,
      id: null,
  }, {
  refetchOnMountOrArgChange: true, //  forces fresh data each mount
});

    const { data: modifierGrpData, isLoading: modifierGrpLoading } = useGetModifierGrpQuery({
    productBrandId: "",
    productCategoryId: "",
    productTagIds: null,
    modifierViewOnline: null,
    createdDateStart: null,
    createdDateEnd: null,
    searchText: currentSearchQuery,
    createdDate: null,
    id: null,
  });


 const {
    data: updateData,
    isLoading: updateIsLoading,
    isError: updateError,
    refetch: updateInvoice,
} = useUpdateInvoiceStatusQuery({
    mainStatus: "2",
    id: id, 
    po_number: poNumber || "", 
    Mode: String('POS'),
}, { skip: !id });


const [newTax, { isLoading: isWorkOrderLoading }] = useCreateWorkOrderMutation();


// const coursings: IInvoice[] = Array.isArray(data?.data) ? (data?.data as IInvoice[]) : [];
const [monthlyPayments, setMonthlyPayments] = useState<number[]>([]);
const [todaysBookings, setTodaysBookings] = useState<IInvoice[]>([]);
const [lastestInvoices, setLatestInvoices] = useState<IInvoice[]>([]);
const [dueInvoices, setDueInvoices] = useState<IInvoice[]>([]);
// const [payments, setPayments] = useState<Payment[]>([]); 
const [monthlyInvoiceCounts, setMonthlyInvoiceCounts] = useState<number[]>(Array(12).fill(0));
const [activeTab, setActiveTab] = useState<number>(0);
const [filteredItems, setFilteredItems] = useState<any[]>([]); // Filtered items for selected category
const [cartItems, setCartItems] = useState<CartItem[]>([]);
const [showActionButtons, setShowActionButtons] = useState(false);
const [openD, setOpenD] = useState(false);
const [dialogOpen, setDialogOpen] = useState<boolean>(false);

const [discountValue, setDiscountValue] = useState<number>(0);
const [discountDescription, setDiscountDescription] = useState<string>("");
const [totalDiscount, setTotalDiscount] = useState<number>(0);
const [discounts, setDiscounts] = useState<IDiscount[]>([]);
const [selectedCustomer, setSelectedCustomer] = useState<ICustomer | null>(null);
const [editingIndex, setEditingIndex] = useState<number | null>(null);
const [subTotal, setSubTotal] = useState(0);
const [hstAmount, setHstAmount] = useState(0);
const [grandTotal, setGrandTotal] = useState(0);

const [payments, setPayments] = useState<Payment[]>([]);
const [method, setMethod] = useState("Cash");
const [amount, setAmount] = useState("0");
const [selectedProduct, setSelectedProduct] = useState<IProductPopUP | null>(null);
const [variants, setVariants] = useState<Variant[]>([]);
const [productId, setProductId] = useState<string>(""); 
const [selectedModifiers, setSelectedModifiers] = useState<Record<number, string[]>>({});
const [openGameModal, setOpenGameModal] = useState(false);
const [openWeightModal, setOpenWeightModal] = useState(false);
const [weightInput, setWeightInput] = useState('');
const [gameProduct, setGameProduct] = useState<IProductPopUP | null>(null);

const [expandedModifiers, setExpandedModifiers] = useState<{ open: boolean, product: any | null   }>({
  open: false,
  product: null,
});

const [expandedLinks, setExpandedLinks] = useState<{ open: boolean, product: any | null   }>({
  open: false,
  product: null,
});

 const { data: variantData, isLoading: variantLoading } =
    useGetVariantQuery({  searchText: "",
    id: null,
    productId: "",
    productBrandId: null,
    productCategoryId: null,
    productTagIds: null,
    productViewOnline: null,
    createdDateStart: null,
    createdDateEnd: null,
    createdDate: null,
  });

const paymentMethods = ["Cash", "Credit", "Debit"];

const now = new Date();
const formattedDateTime = now.getFullYear() + '-' +
  String(now.getMonth() + 1).padStart(2, '0') + '-' +
  String(now.getDate()).padStart(2, '0') + ' ' +
  String(now.getHours()).padStart(2, '0') + ':' +
  String(now.getMinutes()).padStart(2, '0') + ':' +
  String(now.getSeconds()).padStart(2, '0');


// const { data: categoryData, isLoading: categoryLoading } =
// useGetSalesCategoryQuery();

  const { data: categoryData,  isLoading: categoryLoading  } = useGetAllMainCategoryQuery({
     departmentId: "",
     coursingId: "",
     roleId: null,
     taxeId: "",
     createdDateStart: null,
     createdDateEnd: null,
     searchText: "",
     numberOfLength: 0,
     isActive: true,
     categoryIsLooping: null,
     createdDate: null
   });

// const { data: categoryData, isLoading: categoryLoading } =
// useGetAllCategoryNameQuery();

// const categoryList = useMemo(() => {
// return categoryData?.data as ISalesCategory[];
// }, [categoryData?.data]);

const { data: subCategoryData, refetch: refetchSubCategories } =
    useGetSubCategoryByArrayQuery({
      parent_ids: selectedCategoryId ? [Number(selectedCategoryId)] : [],
    });

  const { data: subCategory2Data, refetch: refetchS2bCategories } =
    useGetSubCategoryByArrayQuery({
      parent_ids: selectedSubCategoryId
        ? [Number(selectedCategoryId), Number(selectedSubCategoryId)]
        : [],
    });

  const { data: subCategory3Data, refetch: refetchS3bCategories } =
    useGetSubCategoryByArrayQuery({
      parent_ids: selectedSubCategoryId
        ? [
            Number(selectedCategoryId),
            Number(selectedSubCategoryId),
            Number(selectedSubToSubCategoryId),
          ]
        : [],
    });




const categoryList = useMemo(() => {
return categoryData?.data as ICategory[];
}, [categoryData?.data]);

  const subCategoryList = useMemo(() => {
    return subCategoryData?.data as ICategory[];
  }, [subCategoryData?.data]);

  const subToSubCategoryList = useMemo(() => {
    return subCategory2Data?.data as ICategory[];
  }, [subCategory2Data?.data]);

  const subToSubToSubCategoryList = useMemo(() => {
    return subCategory3Data?.data as ICategory[];
  }, [subCategory3Data?.data]);


 const productList: any[] = Array.isArray(productData?.data)
    ? (productData?.data as any[])
    : [productData?.data];

        const modifierGrpList: IModifierGrpPopUp[] = Array.isArray(modifierGrpData?.data)
      ? (modifierGrpData?.data as IModifierGrpPopUp[])
              : [];

    
const variantList: IVariantPopUP[] = Array.isArray(variantData?.data)
      ? (variantData?.data as IVariantPopUP[])
      : [];

const { data: workOrderLastData, isLoading: workOrderIsLoading } =
    useGetLastWorkOrderIdQuery();

    const rawData = workOrderLastData?.data;
  const workOrderId =
    typeof rawData === "number"
      ? rawData
      : parseInt(rawData as string, 10) || 0;

const generateWorkOrderNumber = (workOrderId: number) => {
  const date = new Date();
  const year = date.getFullYear().toString().slice(2);
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  return `WO${year}${month}${day}-${workOrderId.toString().padStart(2, "0")}`;
};

const generatedWorkOrderNo = generateWorkOrderNumber(workOrderId);

 const customerList: ICustomer[] = Array.isArray(data?.data)
    ? (data?.data as ICustomer[])
    : [];

    const filterOptions = createFilterOptions({
      matchFrom: 'any', // Match anywhere in the string
      stringify: (option: any) => {
        if (typeof option === 'string') return option;
        // Combine fields for searching
        return `${option.customerFirstName} ${option.customerLastName} ${option.customerMobileNum}`;
      },
    });
    

const handleNumberClick = (num: any) => {
  setInput((prev) => prev + num);
};

const handleDelete = () => {
  setInput((prev) => prev.slice(0, -1));
};

const handleEnter = () => {
  const paid = parseFloat(input) || 0;
 // const total = grandTotal; // Convert grandTotal to a number
  const total = splitPayment ? parseFloat(amount) || 0 : grandTotal || 0;

 const rawChange = paid - total;

  setAmountPaid(paid);
 setChange(rawChange > 0 ? parseFloat(rawChange.toFixed(2)) : 0); // Money to return
  //setDueAmount(rawChange < 0 ? parseFloat(Math.abs(rawChange).toFixed(2)) : 0); // Money still owed
  //setInput("");
  setShowActionButtons(true); 
};

const handlePresetAmount = (amount: number) => {
  setInput(String(amount)); 
};


const calculateItemTotal = (item: any) => {
  const price = item.offerPrice ?? item.salePrice;
  let quantity = item.quantity;

  if (item.productConversionUnit?.includes(6)) {
    quantity = quantity / 1000;
  }

  return price * quantity;
};

useEffect(() => {
  AOS.init({
    duration: 800, // animation duration
    once: true,    // animate only once
  });
}, []);

const subTotalValue  = cartItems.reduce((acc, item) => {
  const price = item.salePrice > 0 ? item.salePrice : item.productPrice;

    let quantity = item.quantity;

   if (item.productConversionUnit?.includes(6)) {
    quantity = quantity / 1000;
  }

   return acc + price * quantity; 
}, 0);

// const subTotal = subTotalValue.toFixed(2); // for display

// const hstAmount = parseFloat((0.13 * subTotalValue).toFixed(2));


// const grandTotal = (
//   cartItems.reduce((acc, item) => {
//     const price = item.salePrice > 0 ? item.salePrice : item.regularPrice;
//     return acc + price * item.quantity;
//   }, 0) * 1.13 // Apply 13% tax
// ).toFixed(2);



   const filteredSerials = useMemo(() => {
    if (!searchTextSerialized) return selectedSerialProducts;

    return selectedSerialProducts.filter((serial) => {
      const serialNo = serial.SERIALNO?.toLowerCase() || "";
      const modelNo = serial.modelNo?.toLowerCase() || "";
      const search = searchTextSerialized.toLowerCase();
      return serialNo.includes(search) || modelNo.includes(search);
    });
  }, [searchTextSerialized, selectedSerialProducts]);

  const availableSerials = filteredSerials.filter(
  (serial) => !serial.isSold // or whatever field marks it sold
);



  useEffect(() => {
    if (debouncedSearchQuery.length >= 4 || debouncedSearchQuery === "") {
      setCurrentSearchQuery(debouncedSearchQuery);
      refetch();
    }
  }, [debouncedSearchQuery]);

useEffect(() => {
  // const subTotalValue = cartItems.reduce((acc, item) => {
  //   const price = item.salePrice > 0 ? item.salePrice : item.regularPrice;
  //   return acc + price * item.quantity;
  // }, 0);

  const hst = parseFloat((0.13 * subTotalValue).toFixed(2));
  const grand = parseFloat((subTotalValue + hst).toFixed(2));

  setSubTotal(parseFloat(subTotalValue.toFixed(2)));
  setHstAmount(hst);
  setGrandTotal(grand);
}, [cartItems]);

 

// useEffect(() => {
//     const subTotal = cartItems.reduce((acc, row) => acc + row.total, 0);


//     const calculatedTotalDiscount = discounts.reduce(
//       (acc, discount) => acc + (discount.value ?? 0),
//       0
//     );
//     setTotalDiscount(calculatedTotalDiscount);

//     const unitPriceDiscount = totalDiscount / subTotal;
//     setUnitPrice(unitPriceDiscount);

//     const updatedRows = cartItems.map((row) => {
//       const price = row.salePrice > 0 ? row.salePrice : row.regularPrice ?? 0;

//       const quantity = row.quantity ?? 0;
//       const tax = row.tax ?? 0;

//       const priceWithDiscount = price * (1 - unitPriceDiscount);

//       const unitProductPriceWithDiscountAndTax =
//         priceWithDiscount * (1 + tax / 100);

//       const totalWithDiscountAndTax =
//         priceWithDiscount * quantity * (1 + tax / 100);

//         const taxAmountWithDiscount = priceWithDiscount * (tax / 100);

//       return {
//         ...row,
//         unitPriceWithDiscount: unitProductPriceWithDiscountAndTax,
//         unitTotalWithDiscount: totalWithDiscountAndTax,
//         taxAmount: taxAmountWithDiscount, 
//       };
//     });

//     setCartItems(updatedRows);

//     // Calculate the grand total with discount
//     const totalSubTotalWithDiscount = updatedRows.reduce(
//       (acc, row) => acc + row.unitTotalWithDiscount,
//       0
//     );
//     setGrandTotalWithDiscount(totalSubTotalWithDiscount);
//   }, [cartItems, discounts]);

useEffect(() => {
  if (!productId) return;

  const fetchVariants = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
      };

      const res = await axios.post(
        `${API_URL}/variants`,
        { productId }, // send productId in the body
        { headers }    // headers in the config
      );

      if (res.data && res.data.status && Array.isArray(res.data.data)) {
        const loadedVariants = res.data.data.map((v: any) => ({
          id: v.id, 
          variantName: v.variantName || "",
          price: v.price?.toString() || "",
          isActive: v.isActive === 1 || v.isActive === true,
        }));
        setVariants(loadedVariants.length > 0 ? loadedVariants : [
          {
            variantName: "",
            price: "",
            isActive: true,
          },
        ]);
      }
    } catch (error) {
      console.error("Error fetching variants:", error);
    }
  };

  fetchVariants();
}, [productId]);

  useEffect(() => {
    const fetchExpenses = async () => {
      try {
        const response = await axios.get(`${API_URL}/view-expenses`);
        setExpenses(response.data); // Set the fetched data to state
    
        
      } catch (error) {
        console.error("Failed to load expenses", error);
      }
    };


    const fetchTeam = async () => {
      try {
        const response = await axios.get(`${API_URL}/view-team`);
        // setTeam(response.data.data);
        const team: Driver[] = response.data.data;
        const managers = team.filter(driver => driver.driverUserRole === 'manager');
        setTeam(managers); 
       // console.log(response.data.data);
      } catch (error) {
        console.error("Failed to load team members", error);
      }
    };

    const fetchDeposit = async () => {
      try {
        const response = await axios.get(`${API_URL}/view-deposit`);
        setDeposit(response.data); // Set the fetched data to state
        // console.log(response.data);
      } catch (error) {
        console.error("Failed to load expenses", error);
      }
    };

    const fetchUserInfo = async () => {
      try {
          const response = await axios.post(
              `${API_URL}/user/userInfo`,
              {}, // No body required
              {
                  headers: {
                      'Content-Type': 'application/json',
                      Authorization: `Bearer ${localStorage.getItem('token') || ''}`, // Include token from localStorage
                  },
              }
          );
          setUserInfo(response.data.data); // Update your state with the response
        //console.log(response.data.data)
      } catch (error) {
          console.error('Error fetching user info', error);
      }
  };

  const fetchCustomerList = async () => {
    try {
      const response = await axios.post(
        `${API_URL}/customer/getAll`, // 
        {}, // No body required
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('token') || ''}`, 
          },
        }
      );
      const customers = response.data.data;
      const activeClients = customers.filter((customer: any) => customer.isDelete === 0);
      setCustomers(activeClients);
      setTotalClients(activeClients.length);
    } catch (error) {
      console.error('Error fetching customers', error);
  
    }
  }

  
    // fetchExpenses();
    // fetchCategories();
    // fetchTeam();
    // fetchDeposit();
    fetchUserInfo();
    fetchCustomerList();
  }, [API_URL]);



  useEffect(() => {
    fetchInstantSales();
  }, []);

  const fetchInstantSales = async () => {
    try {
      const response = await axios.get(`${API_URL}/view-instant-sales`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
        },
      });
      setInstantSales(response.data);
    } catch (error) {
      console.error('Error fetching instant sales:', error);
    } finally {
      setLoading(false);
    }
  };


  const formik = useFormik({
    initialValues: {
      customerFirstName: "",
      customerLastName: "",
      customerMobileNum: "",
      customerEmail: "",
      customerProvince: "",
      customerCity: "",
      customerPostalCode: "",
      customerStreetNumber: "",
      customerStreetName: "",
      customerDescription: "",
      customerCompanyName: "",
      customerCompanyPhoneNumebr: "",
      customerCompanyEmail: "",
      customerPreferTimeToCall: "",
      customerImg: ""
      
    },
    enableReinitialize: true,
    validate: (values) => {
      const errors: { [key: string]: string } = {};

      const companyEmailError = validateEmail(values.customerCompanyEmail);
      if (companyEmailError) {
        errors.customerCompanyEmail = companyEmailError;
      }

      const customerEmailError = validateEmail(values.customerEmail);
      if (customerEmailError) {
        errors.customerEmail = customerEmailError;
      }

      const companyMobileNumberError = validatePhoneNumber(values.customerCompanyPhoneNumebr);
      if (companyMobileNumberError) {
        errors.customerCompanyPhoneNumebr = companyMobileNumberError;
      }

      const cutomerMobileNumberError = validatePhoneNumber(
        values.customerMobileNum
      );
      if (cutomerMobileNumberError) {
        errors.customerMobileNum = cutomerMobileNumberError;
      }

      const cutomerAltMobileNumberError = validatePhoneNumber(
        values.customerMobileNum
      );
      if (cutomerAltMobileNumberError) {
        errors.customerMobileNum = cutomerAltMobileNumberError;
      }

      return errors;
    },
    onSubmit: async (values, { resetForm }) => {
      try {
        const formData = new FormData();
        let customerImg: string | undefined;

        if (selectedImage) {
          setIsImageUploading(true);
          formData.append("customerImg", selectedImage);
          customerImg = (await uploadImage(selectedImage)) || "";
          setIsImageUploading(false);
        }

        const temData = {
          customerFirstName: values.customerFirstName,
          customerLastName: values.customerLastName,
          customerMobileNum: values.customerMobileNum,
          customerEmail: values.customerEmail,

          customerProvince: values.customerProvince,
          customerCity: values.customerCity,
          customerPostalCode: values.customerPostalCode,
          customerStreetNumber: values.customerStreetNumber,
          customerStreetName: values.customerStreetName,

          customerDescription: values.customerDescription,
          customerCompanyName: values.customerCompanyName,
          customerCompanyPhoneNumebr: values.customerCompanyPhoneNumebr,
          customerCompanyEmail: values.customerCompanyEmail,
          customerPreferTimeToCall: values.customerPreferTimeToCall,
          customerImg,
        };

        const addCompanyResponse = await newCustomer(temData).unwrap();
        if (!addCompanyResponse.status) {
          showErrorMessage(addCompanyResponse.message);
        } else {
          showMessage("Customer Created successfully");
          setShowCustomerForm(false);
          // navigate(`/customer-history/${addCompanyResponse.data.id}`);

     // Cast to ICustomer temporarily
setSelectedCustomer(addCompanyResponse.data as unknown as ICustomer);

setSearchQueryCustomer(
  `${(addCompanyResponse.data as unknown as ICustomer).customerFirstName} ${(addCompanyResponse.data as unknown as ICustomer).customerLastName}`
);


          resetForm();
          setSelectedImage(undefined);
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  const formValid = useMemo(() => {
    const { customerFirstName, customerLastName, customerMobileNum, customerEmail } = formik.values;
    return (
      customerFirstName?.trim() !== "" &&
      customerLastName?.trim() !== "" &&
       customerMobileNum?.trim() !== ""
       &&
       customerEmail?.trim() !== ""
    );
  }, [formik.values]);

  // useEffect(() => {
  //   const fetchProducts = async () => {
  //     if (categoryList && categoryList.length > 0) {
  //       setLoading(true);
  //       const selectedCategory = categoryList[activeTab];
  
  //       const headers = {
  //         Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
  //       };
  
  //       try {
  //         const response = await axios.post(
  //           `${API_URL}/product/getAll`,
  //           {
  //             // params: {
  //               productCategoryId: selectedCategory.id,
  //             // },
  //           },
  //           { headers } // headers should be passed as the third argument
  //         );
  
  //         if (response.data.status) {
  //           setMainItems(response.data.data);
  //         }
  //       } catch (error) {
  //         console.error("Error fetching product details:", error);
  //       } finally {
  //         setLoading(false);
  //       }
  //     }
  //   };
  
  //   fetchProducts();
  // }, [activeTab, categoryList]);

  // useEffect(() => {
  //   const fetchVariants = async () => {
  //     if (categoryList && categoryList.length > 0) {
  //       setLoading(true);
  //       const selectedCategory = categoryList[activeTab];
  
  //       const headers = {
  //         Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
  //       };
  
  //       try {
  //         const response = await axios.post(
  //           `${API_URL}/view-variant-details`,
  //           {
  //             // params: {
  //               categoryId: selectedCategory.id,
  //             // },
  //           },
  //           { headers } // headers should be passed as the third argument
  //         );
  
  //         if (response.data.status) {
  //           setVariantDetails(response.data.data);
  //         }
  //       } catch (error) {
  //         console.error("Error fetching variant details:", error);
  //       } finally {
  //         setLoading(false);
  //       }
  //     }
  //   };
  
  //   fetchVariants();
  // }, [activeTab, categoryList]);
  
// useEffect(() => {
//   if (
//     categoryList?.length > 0 &&
//     productList?.length > 0 &&
//     subCategoryList?.length > 0
//   ) {
//     const selectedCategory = categoryList[0];
//     setSelectedCategoryId(selectedCategory.id);

//     setSelectedSubCategoryId(subCategoryList[0].id);

//     if (subToSubCategoryList?.length > 0) {
//       setSelectedSubToSubCategoryId(subToSubCategoryList[0].id);
//     }

//     if (subToSubToSubCategoryList?.length > 0) {
//       setSelectedSubToSubToSubCategoryId(subToSubToSubCategoryList[0].id);
//     }

//     setVariantDetails(
//       productList.filter(
//         (item) =>  item.productViewOnline  ) );
//   }
// }, [
//   categoryList,
//   productList,
//   subCategoryList,
//   subToSubCategoryList,
//   subToSubToSubCategoryList
// ]);

useEffect(() => {
  if (categoryList?.length > 0 && !selectedCategoryId) {
    setSelectedCategoryId(categoryList[0].id);
  }
}, [categoryList]);

useEffect(() => {
  if (!selectedCategoryId) return;

  // Reset sub selections
  setSelectedSubCategoryId(null);
  setSelectedSubToSubCategoryId(null);
  setSelectedSubToSubToSubCategoryId(null);
}, [selectedCategoryId]);



useEffect(() => {
  if (!productList || productList.length === 0)  return;

  // products are already filtered by backend
 // setVariantDetails(productList);
    setVariantDetails(
    productList.filter(
      (item) => item && item.productViewOnline
    )
  );
}, [categoryList,
  productList,
  subCategoryList,
  subToSubCategoryList,
  subToSubToSubCategoryList]);





const getAllRelatedCategoryIds = (selectedCategoryId: number, categoryList: any[]) => {
  const related = [selectedCategoryId];

  // include direct sub-categories
  categoryList.forEach(cat => {
    if (Array.isArray(cat.parent_ids) && cat.parent_ids.includes(selectedCategoryId)) {
      related.push(cat.id);
    }
  });

  return related;
};


const getVisibleSubCategories = () => {
  if (!selectedCategoryId) return [];

  // subCategoryList under main category
  const subCats = subCategoryList?.filter(
    (sub) => String(sub.parent_ids) === String(selectedCategoryId)
  ) || [];

  // subToSubCategoryList under selected main category
  const subToSubCats = subToSubCategoryList?.filter(
    (sub) => String(sub.parent_ids) === String(selectedCategoryId)
  ) || [];

  // subToSubToSubCategoryList under selected main category
  const subToSubToSubCats = subToSubToSubCategoryList?.filter(
  (sub) => String(sub.parent_ids) === String(selectedCategoryId)
  ) || [];

  // combine all for buttons
  return [...subCats, ...subToSubCats, ...subToSubToSubCats];
};



  const handleChangeCategory = (index: number) => {
    setShowInstantSaleForm(false);
    setShowCashForm(false);
    setShowCustomerForm(false);
    setShowDiscountForm(false);
    setShowSplitForm(false);
    setShowingVariants(false);
    setActiveTab(index);
    const selectedCategory = categoryList[index];
    setSelectedCategoryId(selectedCategory.id);
     setSelectedSubCategoryId(null);
    setSelectedSubToSubCategoryId(null);
    setSelectedSubToSubToSubCategoryId(null);
    // const filteredItems = productList.filter(item => item.productCategoryId === selectedCategory.id && item.productViewOnline);
  const filteredItems = productList.filter(item => item?.productViewOnline);
    setVariantDetails(filteredItems);
    //console.log(filteredItems);
  };

   const handleSubCategoryChange = (index: number) => {
    setShowInstantSaleForm(false);
    setShowCashForm(false);
    setShowCustomerForm(false);
    setShowDiscountForm(false);
    setShowSplitForm(false);
    setShowingVariants(false);
    setActiveTab(index);
    // const subCategoryId = subCategoryList[index];
     setSelectedSubCategoryId(index);
    setSelectedSubToSubCategoryId(null);
    setSelectedSubToSubToSubCategoryId(null);
    // const filteredItems = productList.filter(item => item.productCategoryId === selectedCategory.id && item.productViewOnline);
  const filteredItems = productList.filter(item => item?.productViewOnline);
    setVariantDetails(filteredItems);
    //console.log(filteredItems);
  };

     const handleSubToSubCategoryChange = (index: number) => {
    setShowInstantSaleForm(false);
    setShowCashForm(false);
    setShowCustomerForm(false);
    setShowDiscountForm(false);
    setShowSplitForm(false);
    setShowingVariants(false);
    setActiveTab(index);
    const selectedSubToSubCategoryId = subToSubCategoryList[index];
    setSelectedSubToSubCategoryId(index);
    setSelectedSubToSubToSubCategoryId(null);
    // const filteredItems = productList.filter(item => item.productCategoryId === selectedCategory.id && item.productViewOnline);
  const filteredItems = productList.filter(item => item?.productViewOnline);
    setVariantDetails(filteredItems);
    //console.log(filteredItems);
  };



     const handleSubToSubToSubCategoryChange = (index: number) => {
    setShowInstantSaleForm(false);
    setShowCashForm(false);
    setShowCustomerForm(false);
    setShowDiscountForm(false);
    setShowSplitForm(false);
    setShowingVariants(false);
    setActiveTab(index);
    const selectedSubToSubToSubCategoryId = subToSubToSubCategoryList[index];
    setSelectedSubToSubToSubCategoryId(index);
    // const filteredItems = productList.filter(item => item.productCategoryId === selectedCategory.id && item.productViewOnline);
  const filteredItems = productList.filter(item => item?.productViewOnline);
    setVariantDetails(filteredItems);
    //console.log(filteredItems);
  };







  const handleProductClick = (product: any) => {
  if (product.hasVariants) {
    const matchedVariants = productList.filter(variant =>
      product.variantIds?.includes(variant.id)
    );
    setSelectedProduct(product);
    setSelectedVariants(matchedVariants);
    setShowVariantDialog(true); // Open a modal/dialog
  } else {
    handleAddToCart(product); // Add directly if no variants
  }
};

  
// const handleAddToCart = (product: any) => {
//   setCartItems(prevItems => {
//     const existing = prevItems.find(
//       item => item.id === product.id && item.productName === product.productName
//     ); // Check both ID and Name

//     if (existing) {
//       return prevItems.map(item =>
//         item.id === product.id
//           ? { ...item, quantity: item.quantity + 1 }
//           : item
//       );
//     } else {
//       return [...prevItems, { ...product, quantity: 1 }];
//     }
//   });
// };

const handleAddToCart = (product: any) => {
  setCartItems(prevItems => {
    const existing = prevItems.find(
      item => item.id === product.id && item.productName === product.productName
    );

    if (existing) {
      if (product.type === "serialized") {
        // Add serial to serializedItems array
        const updatedProduct = {
          ...existing,
          serializedItems: [
            ...(existing.serializedItems || []),
            {
              SERIALNO: product.SERIALNO,
              modelNo: product.modelNo,
              IMEI: product.IMEI,
              sellingPrice: product.sellingPrice,
              buyingPrice: product.buyingPrice,
              vendorId: product.vendorId,
            }
          ]
        };
        return prevItems.map(item =>
          item.id === product.id ? updatedProduct : item
        );
      } else {
        // Normal product: just increase quantity
        return prevItems.map(item =>
          item.id === product.id
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      }
    } else {
      // New product
      return [
        ...prevItems,
        {
          ...product,
          quantity: product.type === "serialized" ? 1 : product.quantity || 1,
          serializedItems: product.type === "serialized"
            ? [{
                SERIALNO: product.SERIALNO,
                modelNo: product.modelNo,
                IMEI: product.IMEI,
                sellingPrice: product.sellingPrice,
                buyingPrice: product.buyingPrice,
                vendorId: product.vendorId,
              }]
            : [],
        }
      ];
    }
  });
};




const updateQuantity = (id: number, delta: number) => {
  setCartItems(prevItems =>
    prevItems.map(item =>
      item.id === id
        ? { ...item, quantity: Math.max(1, item.quantity + delta) }
        : item
    )
  );
};

 if ( categoryLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );
  }


  const handleInstantSaleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      const response = await axios.post(`${API_URL}/save-instant-sales`, instantSaleForm, {
        headers: {
          'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('token') || ''}`
        },
      });

      const newSale = response.data; // Assuming API returns the created sale
    
      // Update cartItems by adding new sale
      setCartItems((prevCartItems) => [
        ...prevCartItems,
        {
          id: newSale.id, // Use actual ID from API
          productName: newSale.product_name,
          salePrice: parseFloat(newSale.price),
          productPrice: parseFloat(newSale.price), // Default to same if no discount
          quantity: 1, // Default to 1
        }
      ]);
           
      showMessage("Instant Sales added successfully!");
      fetchInstantSales();
      // Optionally: Reset form
      setInstantSaleForm({
        product_name: '',
        price: '',
        hst: false,
        description: '',
      });
     
    } catch (error) {
      console.error('Error saving instant sale:', error);
      showErrorMessage("Error saving. Please check input and try again.")
    }
  };
  

  const handleWalkIn = () =>{
    setWalkIn(true);
    //setSelectedCustomer(null);
  setSelectedCustomer(WALK_IN_CUSTOMER);
  }

  const handleShowInstantSaleForm = () => {
    setShowInstantSaleForm(true);
    setShowCashForm(false);
    setShowCustomerForm(false);
    setShowDiscountForm(false);
    setShowSplitForm(false);
  };

  const handleShowCashForm = () => {

    if (!selectedCustomer) {
    alert("Please select a customer or choose Walk-in");
    return;
  }
    
    setShowInstantSaleForm(false);
    setShowCashForm(true);
    setShowCustomerForm(false);
    setShowDiscountForm(false);
    setShowSplitForm(false);
  };

  const handleShowCustomerForm = () => {
    setShowInstantSaleForm(false);
    setShowCashForm(false);
    setShowCustomerForm(true);
    setShowDiscountForm(false);
    setShowSplitForm(false);
  };

  const handleShowDiscountForm = () => {
    setShowInstantSaleForm(false);
    setShowCashForm(false);
    setShowCustomerForm(false);
    setShowDiscountForm(true);
    setShowSplitForm(false);
  };

  const handleShowSplitForm = () => {
    setShowInstantSaleForm(false);
    setShowCashForm(false);
    setShowCustomerForm(false);
    setShowDiscountForm(false);
    setShowSplitForm(true);
  };



  const handleOpenCashDrawer = () => {
 //   console.log("Opening cash drawer...");
    // Optional: trigger hardware event if supported
  };

// const handleSaveInvoice = async ( paymentMethod: "Cash" | "Credit" | "Debit") => {


// const isCardPayment = paymentMethod === "Credit" || paymentMethod === "Debit";
// const remainingBalance = Math.max(grandTotal - amtPaid, 0);
//         const paymentAmount = splitPayment
//   ? isCardPayment
//     ? remainingBalance       // ✅ card pays ONLY remaining
//     : Number(amount)         // cash input
//   : isCardPayment
//     ? grandTotal
//     : amountPaid - change;

// const finalPaidAmount = isCardPayment
//   ? grandTotal
//   : amountPaid;

// const finalChange = isCardPayment
//   ? 0
//   : change;

//     let invoiceId = id; // Track invoice id

//     const TAX_RATE = 13;
//     try {
//       const headers = {
//         Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
//       };
//       if (!invoiceId) {
//       // Create product rows from cartItems
//     const productRows = cartItems.map(item => {
//   // const price = item.salePrice ;
//   const price = item.offerPrice ?? item.salePrice;

//   const productPrice = item.productPrice;
//   const quantity = item.quantity;
//   const itemTotal = price * quantity;

//   // Proportional discount for this item
//   const itemDiscount = subTotalValue > 0
//     ? (itemTotal / subTotalValue) * totalDiscount
//     : 0;

//   const discountedSubtotal = itemTotal - itemDiscount;

//   const taxAmount = parseFloat(((discountedSubtotal * TAX_RATE) / 100).toFixed(2));
//   const unitTotalWithDiscount = parseFloat((discountedSubtotal + taxAmount).toFixed(2));

//   return {
//     productId: item.id,
//     productName: item.productName,
//     quantity: quantity,
//     price: price,
//     productPrice: productPrice,
//     tax: TAX_RATE,
//     taxAmount: taxAmount,
//     unitTotalWithDiscount: unitTotalWithDiscount,
//     transferTypeFrom: "",
//     transferTypeTo: "",
//      serializedItems: item.serializedItems?.map(s => ({
//       SERIALNO: s.SERIALNO ?? null,
//       modelNo: s.modelNo ?? null,
//       IMEInO: s.IMEInO ?? null,
//     })) || [],
//   };
// });





//       const invoiceData = {
//         // paidAmount: amountPaid,
//         // change: change.toFixed(2),
//         // paymentType: "Cash",

//         paidAmount: finalPaidAmount,
//         change: finalChange.toFixed(2),
//         paymentType: paymentMethod,
  
//         //customerId: selectedCustomerId || null,
//         quoteWorkOrderNo: generatedWorkOrderNo,
//         quoteWorkOrderSale: productRows,
//         // quoteWorkOrderDiscount: String(totalDiscount),
//         quoteWorkOrderSubTotal: String(subTotal),
//         quoteWorkOrderSaleGrandTotal: String(grandTotal),
//         quoteWorkOrderIssueDate: now,
//         // quoteWorkOrderSaleDiscountDescription: discounts,
//          quoteWorkOrderCompanyId: String(1),
//          amount:String(grandTotal),
//           // customer_paid: amountPaid,
//           // customer_change:change.toFixed(2),
//           customer_paid: finalPaidAmount,
//           customer_change: finalChange.toFixed(2),
//         //  amount_paid: amountPaid,
//         //  due_amount:change.toFixed(2),
//          quoteWorkOrderCustomerId: String(selectedCustomer?.id || 0),
//          quoteWorkOrderDiscount: String(totalDiscount),
//          quoteWorkOrderSaleDiscountDescription: discounts,
//         // quoteWorkOrderCustomerRemark: values.quoteWorkOrderCustomerRemark,
//         // quoteWorkOrderCustomerMemo: values.quoteWorkOrderCustomerMemo,
//       };
//       // console.log(invoiceData);
//       const response = await newTax(invoiceData).unwrap();
  
//       if (!response.status) {
//         showErrorMessage(response.message);
//         return;
//       }

//       invoiceId = response.data?.id;
//       setId(invoiceId);
//       showMessage("Invoice saved successfully!");

//       for (const item of cartItems) {
//   const ticketPayload = {
//     order_id: invoiceId,
//     wp_page_id: item.wp_page_id || null,
//     event_id: item.id,
//     booked_quantity: item.quantity,
//   };

//   // 1️⃣ Create ticket
//   await axios.post(`${API_URL}/save-order-ticket`, ticketPayload, { headers });

//   // 2️⃣ Update sold quantity
//   await axios.post(`${API_URL}/update-sold-quantity`, {
//     event_id: item.id,
//     quantity: item.quantity,
//   }, { headers });
// }


//       // setOpenD(true);
//       if (!splitPayment) cancelFunction();
//       setShowActionButtons(false);
    
//     }



    
//     const formData = new FormData();
//     formData.append("work_order_id", invoiceId);
//     // formData.append("amount", splitPayment ? String(amount) : String(amountPaid - change));
//     // formData.append("paymentMethod", "Cash");
//    formData.append("amount", String(paymentAmount));


//     formData.append("paymentMethod", paymentMethod);

//     formData.append("payment_mode", "OFFLINE");

//     await new Promise(resolve => setTimeout(resolve, 1000));

  
//         const paymentResponse = await axios.post(`${API_URL}/save-payment`, formData, { headers });
           
//         await axios.post(
//   `${API_URL}/send-event-booking-email`,
//   { invoice_id: invoiceId },
//   { headers }
// );
        
//         if(splitPayment){
//               showMessage("Payments saved succesfully!");
//               const paidAmount = paymentResponse.data?.invoice?.amount_paid ?? 0;
//               const grandTotalFromServer = parseFloat(paymentResponse.data?.invoice?.quoteWorkOrderSaleGrandTotal ?? 0);
//               setAmtPaid(paidAmount);

//     const newRemaining = Math.max(grandTotalFromServer - paidAmount, 0);
//     setAmount(newRemaining.toFixed(2)); 

//         if(paymentMethod === "Cash") setAmountPaid(0.0);

//     setShowSplitForm(newRemaining > 0);

//               //setAmount("0");
//              // setAmountPaid(0.00);
//              // setShowSplitForm(true); 
//               if (paidAmount >= grandTotal) {
//                 cancelFunction();
//                 setShowCashForm(false);
//                 setShowSplitForm(false); 
//               } 
//          }
//         setShowCashForm(false);

      
//     } catch (error) {
//       showErrorMessage("Something went wrong while saving invoice.");
//     }
//   };

  
// const handleSaveInvoice = async (paymentMethod: "Cash" | "Credit" | "Debit") => {
 
// if (!selectedCustomer) {
//     alert("Please select a customer or choose Walk-in");
//     return;
//   }
 
//   if (actionLoading === paymentMethod) return;

//   setActionLoading(paymentMethod);
 
 
//   const isCardPayment = paymentMethod === "Credit" || paymentMethod === "Debit";
//   const remainingBalance = Math.max(grandTotal - amtPaid, 0);
//   const paymentAmount = splitPayment
//     ? isCardPayment
//       ? remainingBalance
//       : Number(amount)
//     : isCardPayment
//       ? grandTotal
//       : amountPaid - change;

//   const finalPaidAmount = isCardPayment ? grandTotal : amountPaid;
//   const finalChange = isCardPayment ? 0 : change;

//   let invoiceId = id;
//   const TAX_RATE = 13;
//   const headers = { Authorization: `Bearer ${localStorage.getItem("token") || ""}` };

//   try {
//     // 1️⃣ Prepare product rows
//     const productRows = cartItems.map(item => {
//       const price = item.offerPrice ?? item.salePrice;
//       const quantity = item.quantity;
//       const itemTotal = price * quantity;
//       const itemDiscount = subTotalValue > 0 ? (itemTotal / subTotalValue) * totalDiscount : 0;
//       const discountedSubtotal = itemTotal - itemDiscount;
//       const taxAmount = parseFloat(((discountedSubtotal * TAX_RATE) / 100).toFixed(2));
//       const unitTotalWithDiscount = parseFloat((discountedSubtotal + taxAmount).toFixed(2));

//       return {
//         productId: item.id,
//         productName: item.productName,
//         quantity,
//         price,
//         productPrice: item.productPrice,
//         tax: TAX_RATE,
//         taxAmount,
//         unitTotalWithDiscount,
//         transferTypeFrom: "",
//         transferTypeTo: "",
//         serializedItems: item.serializedItems?.map(s => ({
//           SERIALNO: s.SERIALNO ?? null,
//           modelNo: s.modelNo ?? null,
//           IMEInO: s.IMEInO ?? null,
//         })) || [],
//       };
//     });

//     // 2️⃣ Create invoice if not exists
//     if (!invoiceId) {
//       const invoiceData = {
//         paidAmount: finalPaidAmount,
//         change: finalChange.toFixed(2),
//         paymentType: paymentMethod,
//         quoteWorkOrderNo: generatedWorkOrderNo,
//         quoteWorkOrderSale: productRows,
//         quoteWorkOrderSubTotal: String(subTotal),
//         quoteWorkOrderSaleGrandTotal: String(grandTotal),
//         quoteWorkOrderIssueDate: now,
//         quoteWorkOrderCompanyId: String(1),
//         amount: String(grandTotal),
//         customer_paid: finalPaidAmount,
//         customer_change: finalChange.toFixed(2),
//         quoteWorkOrderCustomerId: String(selectedCustomer?.id || 0),
//         quoteWorkOrderDiscount: String(totalDiscount),
//         quoteWorkOrderSaleDiscountDescription: discounts,
//       };

//       const response = await newTax(invoiceData).unwrap();
//       if (!response.status) throw new Error(`Invoice creation failed: ${response.message}`);

//       invoiceId = response.data?.id;
//       setId(invoiceId);
//      // showMessage("Invoice created successfully!");
//     }

//     // 3️⃣ Create tickets and update sold quantity
//     for (const item of cartItems) {
//       try {
//         const ticketPayload = {
//           order_id: invoiceId,
//           wp_page_id: item.wp_page_id || null,
//           event_id: item.id,
//           booked_quantity: item.quantity,
//         };
//         await axios.post(`${API_URL}/save-order-ticket`, ticketPayload, { headers });

//         await axios.post(`${API_URL}/update-sold-quantity`, {
//           event_id: item.id,
//           quantity: item.quantity,
//         }, { headers });
//       } catch (ticketError: unknown) {
//         //throw new Error(`Failed to create ticket or update sold quantity for ${item.productName}`);
//        console.error("Failed to create ticket", ticketError);
//       }
//     }

//     // 4️⃣ Save payment
//     try {
//       const formData = new FormData();
//       formData.append("work_order_id", invoiceId);
//       formData.append("amount", String(paymentAmount));
//       formData.append("paymentMethod", paymentMethod);
//       formData.append("payment_mode", "OFFLINE");

//       await new Promise(resolve => setTimeout(resolve, 1000));
//       const paymentResponse = await axios.post(`${API_URL}/save-payment`, formData, { headers });

//       // Update split payment UI
//       if (splitPayment) {
//         const paidAmount = paymentResponse.data?.invoice?.amount_paid ?? 0;
//         const grandTotalFromServer = parseFloat(paymentResponse.data?.invoice?.quoteWorkOrderSaleGrandTotal ?? 0);
//         setAmtPaid(paidAmount);

//         const newRemaining = Math.max(grandTotalFromServer - paidAmount, 0);
//         setAmount(newRemaining.toFixed(2));

//         if (paymentMethod === "Cash") setAmountPaid(0.0);
//         setShowSplitForm(newRemaining > 0);

//         if (paidAmount >= grandTotal) {
//           cancelFunction();
//           setShowCashForm(false);
//           setShowSplitForm(false);
//         }
//       }
//     } catch (paymentError: unknown) {
//        console.error("Failed to save payments", paymentError);
//        showMessage("Failed to save payments");
//     }
// setTimeout(async () => {
//     // 5️⃣ Send booking email
//     try {
//       await axios.post(`${API_URL}/send-event-booking-email`, { invoice_id: invoiceId }, { headers });
//     } catch (emailError: unknown) {
//       console.error("Email sending failed", emailError);
//        showMessage("Failed to send booking email");
  
//     }
// }, 1000); 
//     setShowCashForm(false);
//     setShowActionButtons(false);

//     if (!splitPayment) cancelFunction();

//     showMessage("Invoice created successfully!");

//   } catch (error: any) {
//     // Main catch for all errors
//     showErrorMessage(error.message || "Something went wrong while saving invoice.");
 
//   }
//   finally {
//   setActionLoading(null); 
// }
// };


const handleSaveInvoice = async (paymentMethod: "Cash" | "Credit" | "Debit") => {
 
if (!selectedCustomer) {
    alert("Please select a customer or choose Walk-in");
    return;
  }
 
  if (actionLoading === paymentMethod) return;

  setActionLoading(paymentMethod);
 
 
  const isCardPayment = paymentMethod === "Credit" || paymentMethod === "Debit";
  const remainingBalance = Math.max(grandTotal - amtPaid, 0);
  const paymentAmount = splitPayment
    ? isCardPayment
      ? remainingBalance
      : Number(amount)
    : isCardPayment
      ? grandTotal
      : amountPaid - change;

  const finalPaidAmount = isCardPayment ? grandTotal : amountPaid;
  const finalChange = isCardPayment ? 0 : change;

  let invoiceId = id;
  const TAX_RATE = 13;
  const headers = { Authorization: `Bearer ${localStorage.getItem("token") || ""}` };

    const eventsCategoryId = categoryList.find(
    (cat) => cat.categoryName?.toLowerCase() === "events"
  )?.id;



  try {
    // 1️⃣ Prepare product rows
    const productRows = cartItems.map(item => {
    
 
      const price = item.offerPrice ?? item.salePrice;
      let  quantity = item.quantity;

    if (item.productConversionUnit?.includes(6)) {
  // Assume price is per KG and cashier enters grams
  quantity = quantity / 1000;
}

//  If product supports GM only
else if (item.productConversionUnit?.includes(5)) {
  // price per gram (no conversion)
  quantity = quantity;
}

      const itemTotal = price * quantity;
      const itemDiscount = subTotalValue > 0 ? (itemTotal / subTotalValue) * totalDiscount : 0;
      const discountedSubtotal = itemTotal - itemDiscount;
      const taxAmount = parseFloat(((discountedSubtotal * TAX_RATE) / 100).toFixed(2));
      const unitTotalWithDiscount = parseFloat((discountedSubtotal + taxAmount).toFixed(2));

      return {
        productId: item.id,
        productName: item.productName,
        quantity,
        price,
        productPrice: item.productPrice,
        tax: TAX_RATE,
        taxAmount,
        unitTotalWithDiscount,
        transferTypeFrom: "",
        transferTypeTo: "",
        serializedItems: item.serializedItems?.map(s => ({
          SERIALNO: s.SERIALNO ?? null,
          modelNo: s.modelNo ?? null,
          IMEInO: s.IMEInO ?? null,
        })) || [],
        slotIds: item.slotIds || [],
    timeSlots: item.slotTimes || [],
    bookedDate: item.date || null,
      };
    });

    // 2️⃣ Create invoice if not exists
    if (!invoiceId) {
      const invoiceData = {
        paidAmount: finalPaidAmount,
        change: finalChange.toFixed(2),
        paymentType: paymentMethod,
        quoteWorkOrderNo: generatedWorkOrderNo,
        quoteWorkOrderSale: productRows,
        quoteWorkOrderSubTotal: String(subTotal),
        quoteWorkOrderSaleGrandTotal: String(grandTotal),
        quoteWorkOrderIssueDate: now,
        quoteWorkOrderCompanyId: String(1),
        amount: String(grandTotal),
        customer_paid: finalPaidAmount,
        customer_change: finalChange.toFixed(2),
        quoteWorkOrderCustomerId: String(selectedCustomer?.id || 0),
        quoteWorkOrderDiscount: String(totalDiscount),
        quoteWorkOrderSaleDiscountDescription: discounts,
      };

      const response = await newTax(invoiceData).unwrap();
      if (!response.status) throw new Error(`Invoice creation failed: ${response.message}`);

      invoiceId = response.data?.id;
      setId(invoiceId);
     // showMessage("Invoice created successfully!");
    }

        const eventItems = cartItems.filter(
      (item) => item.productCategoryId === eventsCategoryId
    );

    // 3️⃣ Save tickets + update sold quantity ONLY for Events
    if (eventItems.length > 0) {

    // 3️⃣ Create tickets and update sold quantity
    // for (const item of cartItems) {
      try {
        await new Promise(resolve => setTimeout(resolve, 1000));
         await Promise.all(
    cartItems.map(async (item) => {
        const ticketPayload = {
          order_id: invoiceId,
          wp_page_id: item.wp_page_id || null,
          event_id: item.id,
          booked_quantity: item.quantity,
        };
        await axios.post(`${API_URL}/save-order-ticket`, ticketPayload, { headers });

        await axios.post(`${API_URL}/update-sold-quantity`, {
          event_id: item.id,
          quantity: item.quantity,
        }, { headers });
          })
  );
      } catch (ticketError: unknown) {
        //throw new Error(`Failed to create ticket or update sold quantity for ${item.productName}`);
       console.error("Failed to create ticket", ticketError);
         return;
      }
    }
    // }

    // 4️⃣ Save payment
    try {
      const formData = new FormData();
      formData.append("work_order_id", invoiceId);
      formData.append("amount", String(paymentAmount));
      formData.append("paymentMethod", paymentMethod);
      formData.append("payment_mode", "OFFLINE");

      await new Promise(resolve => setTimeout(resolve, 1000));
      const paymentResponse = await axios.post(`${API_URL}/save-payment`, formData, { headers });

      // Update split payment UI
      if (splitPayment) {
        const paidAmount = paymentResponse.data?.invoice?.amount_paid ?? 0;
        const grandTotalFromServer = parseFloat(paymentResponse.data?.invoice?.quoteWorkOrderSaleGrandTotal ?? 0);
        setAmtPaid(paidAmount);

        const newRemaining = Math.max(grandTotalFromServer - paidAmount, 0);
        setAmount(newRemaining.toFixed(2));

        if (paymentMethod === "Cash") setAmountPaid(0.0);
        setShowSplitForm(newRemaining > 0);

        if (paidAmount >= grandTotal) {
          cancelFunction();
          setShowCashForm(false);
          setShowSplitForm(false);
        }
      }
    } catch (paymentError: unknown) {
       console.error("Failed to save payments", paymentError);
       showMessage("Failed to save payments");
    }

     if (eventItems.length > 0) {
    // 5️⃣ Send booking email
    try {
      await axios.post(`${API_URL}/send-event-booking-email`, { invoice_id: invoiceId }, { headers });
    } catch (emailError: unknown) {
      console.error("Email sending failed", emailError);
       showMessage("Failed to send booking email");
  
    }
  }

    setShowCashForm(false);
    setShowActionButtons(false);

    if (!splitPayment) cancelFunction();

    showMessage("Invoice created successfully!");

  } catch (error: any) {
    // Main catch for all errors
    showErrorMessage(error.message || "Something went wrong while saving invoice.");
 
  }
  finally {
  setActionLoading(null); 
}
};


   const cancelFunction = () => {
  
    setCartItems([]);
    setShowActionButtons(false);
    setOpenD(false);
    setTimeout(() => {
      setId("");
    }, 300); // 300ms is usually safe
    setAmountPaid(0.00);
    setChange(0.00);
    setAmtPaid(0.00);
    setInput("");
    setSelectedCustomer(null);
    //   setSearchQueryCustomer("");
    //   setCurrentSearchQueryCustomer("");
    //   setSearchQueryProduct("");
    //   setCurrentSearchQueryProduct("");
    //   setShowDropdownProductIndex(null);
       setDiscountDescription("");
    //   setSubTotal(0);
    //   setGrandTotal(0);
    //   // setSelectedCompanyLogo(null);
    //   setProductRows([
    //     {
    //       productName: "",
    //       productDescription: "",
    //       productImg: "",
    //       numberOfPassengers: null || 0,
    //       transferType: TransferType.OneWayTransfer,
    //       transferTypeFrom: "",
    //       transferTypeTo: "",
    //       transferTypeDescription: "",
    //       departureDateTime: null,
    //       returnDateTime: null,
    //       departureAddress: "",
    //       destinationAddress: "",
    //       multiDestination: "",
    //       quantity: 1,
    //       price: null || 0,
    //       tax: null || 0,
    //       taxAmount: null || 0,
    //       total: 0,
    //       taxId: null,
    //       unitPriceWithDiscount: null,
    //       unitTotalWithDiscount: 0,
    //       productType: ProductType.Service,
    //       productLongDescription: "",
    //       productShortDescription: "",
    //     },
    //   ]);
    //   // setDiscounts([{ value: null || 0, description: "" }]);
    setDiscounts([]);
    setTotalDiscount(0);
    //  // navigate(-1);
    };

    const cancelDiscountFunction = () => {
       setDiscountValue(0);
    setDiscountDescription("");
    }
  

    const handleConfirmDialog = async () => {
      setOpenD(false);
  
      if (updateIsLoading) return;
  
      try {
        if (updateData && !updateError) {
          showMessage("Converted to invoice successfully");
          // navigate(-1);
        } else if (updateError) {
          showErrorMessage("Failed to convert to invoice");
        }
      } catch (error) {
        showErrorMessage("Error occurred while converting to invoice");
      }
    };

    const handleCloseDialog = () => {
      setOpenD(false);
    };

    const resizeImage = (
      file: File,
      maxWidth: number,
      maxHeight: number
    ): Promise<File> => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
  
        reader.onload = (event) => {
          const img = new Image();
          img.src = event.target?.result as string;
  
          img.onload = () => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
  
            let width = img.width;
            let height = img.height;
  
            // Calculate the new dimensions while maintaining aspect ratio
            if (width > height) {
              if (width > maxWidth) {
                height *= maxWidth / width;
                width = maxWidth;
              }
            } else {
              if (height > maxHeight) {
                width *= maxHeight / height;
                height = maxHeight;
              }
            }
  
            canvas.width = width;
            canvas.height = height;
            ctx?.drawImage(img, 0, 0, width, height);
  
            canvas.toBlob((blob) => {
              if (blob) {
                const resizedFile = new File([blob], file.name, {
                  type: file.type,
                });
                resolve(resizedFile);
              } else {
                reject(new Error("Canvas is empty"));
              }
            }, file.type);
          };
  
          img.onerror = (error) => reject(error);
        };
      });
    };


  const handleImageChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;

    if (files && files.length > 0) {
      const file = files[0];
      const validTypes = ["image/jpeg", "image/png", "image/jpg", "image/gif"];
      const maxSize = 2048 * 1024;

      if (!validTypes.includes(file.type)) {
        showErrorMessage("The file must be an image (jpeg, png, jpg, gif).");
        setSelectedImage(undefined);
      } else if (file.size > maxSize) {
        showErrorMessage("The file must be smaller than 2 MB.");
        setSelectedImage(undefined);
      } else {
        try {
          const resizedImage = await resizeImage(file, 500, 500);
          setSelectedImage(resizedImage);
        } catch (error) {
          showErrorMessage("Failed to resize the image.");
          setSelectedImage(undefined);
        }
      }
    } else {
      setSelectedImage(undefined);
    }
  };


  const handleSaveDiscount = () => {
    let updatedDiscounts = [];
  
    if (editingIndex !== null) {
      // Update existing discount
      updatedDiscounts = discounts.map((discount, index) =>
        index === editingIndex
          ? { value: discountValue, description: discountDescription }
          : discount
      );
    } else {
      // Add a new discount
      updatedDiscounts = [
        ...discounts,
        { value: discountValue, description: discountDescription },
      ];
    }
  
    // Calculate discount total
    const discountAmount = updatedDiscounts.reduce(
      (acc, d) => acc + Number(d.value || 0),
      0
    );
  
    const updatedSubtotal = subTotalValue; // assuming subTotalValue is the raw subtotal before any discounts
    const updatedHst = parseFloat((0.13 * (updatedSubtotal - discountAmount)).toFixed(2));
    const updatedGrandTotal = parseFloat(((updatedSubtotal - discountAmount) + updatedHst).toFixed(2));
  
    // Set state values
    setDiscounts(updatedDiscounts);
    setTotalDiscount(discountAmount);
    setSubTotal(parseFloat(updatedSubtotal.toFixed(2)));
    setHstAmount(updatedHst);
    setGrandTotal(updatedGrandTotal);
  
    cancelDiscountFunction(); // Reset editing state and clear inputs
  };
  
  const handleDeleteDiscount = (index: number) => {
    const updatedDiscounts = discounts.filter((_, i) => i !== index);
    setDiscounts(updatedDiscounts);
  };



  const handleAddPayment = () => {
    if (!amount || Number(amount) <= 0) return;
    setPayments((prev) => [...prev, { method, amount: parseFloat(amount) }]);
    setAmount("");
  };

  const handleRemove = (index: number) => {
    const updated = [...payments];
    updated.splice(index, 1);
    setPayments(updated);
  };
  
  const paidTotal = payments.reduce((sum, p) => sum + p.amount, 0);
  const remaining = totalAmount - paidTotal;


  const handleCompletePayment = () => {
    payments.forEach((payment) => {
      switch (payment.method) {
        case 'Cash':
          processCash(payment.amount);
          break;
        case 'Debit':
          processDebit(payment.amount);
          break;
        case 'Credit':
          processCredit(payment.amount);
          break;
        default:
          console.warn(`Unknown payment method: ${payment.method}`);
      }
    });
  
    // Optional: Show a toast / snackbar or alert
    alert('Payment completed successfully!');
  
    // Optional: Reset state
    setPayments([]);
    setAmount('');
    setMethod('');
  };
  
  const processCash = (amount: number) => {
   
    console.log(`Processing cash payment: $${amount}`);
    // Your existing logic here (e.g. call API or update backend)
  };
  
  const processDebit = (amount: number) => {
    console.log(`Processing debit payment: $${amount}`);
    // Implement or mock logic
  };
  
  const processCredit = (amount: number) => {
    console.log(`Processing credit payment: $${amount}`);
    // Implement or mock logic
  };
const onProductSelect = (item: IProductPopUP, type: 'product' | 'variant' | 'serialized') => {
 
 

  if (type === 'product') {
// console.log("item.productCategoryId:", item.productCategoryId);
// console.log("gamesCategoryId:", gamesCategoryId);
//  if (item.productCategoryId === gamesCategoryId) {
//    setGameProduct(item);
//      setOpenGameModal(true); // NEW
    
//     return;
//     }

    if (item.hasVariants) {
      setSelectedProduct(item);
      setProductId(item.id);
    } else {

  if (
    item.productConversionUnit?.includes(6) ||
    item.productConversionUnit?.includes(5)
  ) {
    setSelectedProduct(item);
    setOpenWeightModal(true); // open modal to enter grams
    return;
  }

      handleAddToCart({ ...item, type: 'product' }); // Optional: attach type for cart
    }
  } else if (type === 'variant') {
    handleAddToCart({ ...item, type: 'variant' }); // Pass variant directly to cart
  }
  else if (type === 'serialized') {
  handleAddToCart({ ...item, type: 'serialized' });
}
};


const handleWeightConfirm = () => {
  if (!weightInput || Number(weightInput) <= 0) return;

  handleAddToCart({
    ...selectedProduct,
    quantity: Number(weightInput), // store grams entered
    type: 'product'
  });

  setOpenWeightModal(false);
  setWeightInput('');
};


  return (
    <>
 
    
 <Grid container spacing={2} sx={{ backgroundColor: '#eaf4f3'}}>
    <Grid item xs={12} sm={8} md={9} sx={{paddingTop:'14px !important', height: '100vh', }}> 

    <Card className={classes.card} >
      <Grid
        container
        justifyContent={"space-between"}
        spacing={5}
        sx={{ padding: 1, borderColor:'none' }}
      >
        <Grid item lg={3} md={3} sm={6} xs={6} pt={2} alignContent={"center"}>
          <Typography className={classes.cardTitle}></Typography>
          <Grid item>
              <TextField
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CiSearch className={classes.searchWidgetIcon} />
                    </InputAdornment>
                  ),
                  classes: {
                    root: classes.SalesformControlList,
                  },
                }}
                fullWidth
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Search Product"
                sx={{ width: "100%",
                  // '& .MuiOutlinedInput-root': {
                  //   height: '34px',
                  //   paddingLeft: '40px',
                  //   paddingRight: '15px',
                  //   boxShadow: 'none',
                  //   border: 'none', 
                  //   backgroundColor: '#eaf4f3'
                  // },
                }}
                size="small"
              />
            </Grid>
        </Grid>

        <Grid
          item
          lg={6}
          md={6}
          sm={12}
          xs={12}
          sx={{ display: "flex"}}
        >
          <Grid 
            container
            spacing={1}
            justifyContent="center"
         
          >
         <Grid item>
        <Button
          variant="contained"
          
          // startIcon={<LocalPrintshopSharpIcon />}
          className={classes.SalesAddButton}
          sx={{backgroundColor:'#058292 !important'}}
       
        >  Top Sale
        </Button>
        </Grid>

        <Grid item>
        <Button
          variant="contained"
          // startIcon={<LocalPrintshopSharpIcon />}
          className={classes.SalesAddButton}
           
             sx={{backgroundColor:'#058292 !important'}}
        >  Daily Specials
        </Button>
        </Grid>

        <Grid item>
        <Button
          variant="contained"
          // startIcon={<LocalPrintshopSharpIcon />}
          className={classes.SalesAddButton}
          sx={{backgroundColor:'#058292 !important'}}
           
        >  Combo
        </Button>
        </Grid>

            
         
            
          </Grid>
        </Grid>
        <Grid
          item
          lg={3}
          md={3}
          sm={12}
          xs={12}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Grid 
            container
            spacing={1}
            justifyContent="flex-end"
            sx={{  display: "flex" ,'@media print': {
              display: 'none',
            } }}
          >
 <Grid item>
        <Button
          variant="contained"
          // startIcon={<LocalPrintshopSharpIcon />}
          className={classes.SalesAddButton}
          sx={{backgroundColor:'#626262 !important'}}
          onClick={ handleShowInstantSaleForm } // Toggle view
        >
          <AddIcon style={{fontSize:'15px' , marginRight: 2}}/> Instant Sale 
        </Button>
  </Grid>
            
          </Grid>
        </Grid>
      </Grid>
</Card>

      <Grid container spacing={2} >
  {/* Left Sidebar - Category Buttons */}
  <Grid item lg={1.2} md={3} sm={12} xs={12} mt={2} sx={{ height: '100vh',
    overflowY: 'auto',
    scrollbarWidth: 'none', // Firefox
    '&::-webkit-scrollbar': {
      display: 'none', // Chrome, Safari
    },}}>
      <Grid container spacing={2} direction="column">
        {categoryList?.map((category, index) => (
          <Grid item key={category.id} sx={{paddingTop:'8px !important'}}>
         
            <Button
              onClick={() => handleChangeCategory(index)} // your function to change tab
              fullWidth
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                padding: 1,
                // backgroundColor: activeTab === index ? '#f2601f' : '#058292',
                backgroundColor: activeTab === index ? 'rgb(58, 58, 58)' : '#058292',
                color: '#fff',
                textTransform: 'none',
                borderRadius: 1,
                position: 'relative',
                '&:hover': {
                  backgroundColor: '#058292',
                },
              }}
            >
         {/* {category.isOnSale === 1 && (
  <Box
    sx={{
      position: 'absolute',
      top: 0,
      right: 0,
      backgroundColor: '#fdcb5f',
      color: '#058292',
      fontSize: '10px',
      fontWeight: 'bold',
      width: '60px',
      height: '60px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      clipPath: `polygon(
        50% 0%,
        61% 19%,
        80% 20%,
        68% 35%,
        79% 50%,
        68% 65%,
        80% 80%,
        61% 81%,
        50% 100%,
        39% 81%,
        20% 80%,
        32% 65%,
        21% 50%,
        32% 35%,
        20% 20%,
        39% 19%
      )`,
      transform: 'translate(30%, -30%)',
      zIndex: 1,
      border: '2px dashed white',
    }}
  >
    %
  </Box>
)} */}

              <img
               // src={`${LARAVEL_API_URL}/${category.categoryImg}`}
                 src={category.categoryImg ?`${LARAVEL_API_URL}/${String(category.categoryImg)}` : placeholderImage}
                alt={category.categoryName}
                width={35}
                height={25}
              />



              <Typography variant="caption"  style={{fontSize:'13px'}}>
                {category.categoryName}
              </Typography>
            </Button>
          </Grid>
        ))}
      </Grid>
  </Grid>




  <Grid item lg={10.8} md={9} sm={12} xs={12} mt={2} sx={{ background: '#eaf4f3', maxHeight: '600px', overflowY: 'auto',  scrollbarWidth: 'none', // Firefox
    '&::-webkit-scrollbar': {
      display: 'none', // Chrome, Safari
    } }}>
  {showInstantSaleForm ? (
    // Show Form and List
    <Grid container spacing={2}>
      {/* Form Section */}
      <Grid item md={7}>
        <Card sx={{ padding: 2 , minHeight:'600px'}} className={classes.card}>
          <Typography variant="h6" style={{marginBottom:'10px'}} gutterBottom>Add Instant Sale</Typography>
          <form onSubmit={handleInstantSaleSubmit}>
          <TextField
          sx={{color:'#5d7186'}}
          size="small"    
              label="Product Name"
              fullWidth
              margin="normal"
              value={instantSaleForm.product_name}
              onChange={(e) => setInstantSaleForm({ ...instantSaleForm, product_name: e.target.value })}
            />
           
            <TextField
            size="small"    
              label="Price"
              fullWidth
              type="number"
              margin="normal"
              value={instantSaleForm.price}
              onChange={(e) => setInstantSaleForm({ ...instantSaleForm, price: e.target.value })}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={instantSaleForm.hst}
                  onChange={(e) => setInstantSaleForm({ ...instantSaleForm, hst: e.target.checked })}
                />
              }
              label="HST"
            />
            <TextField
              label="Description"
              size="small"
              fullWidth
              multiline
              rows={4}
              margin="normal"
              value={instantSaleForm.description}
              onChange={(e) => setInstantSaleForm({ ...instantSaleForm, description: e.target.value })}
            />
            <Button type="submit" style={{marginBottom:'10px', marginTop:'10px'}} variant="contained"  className={classes.SalesAddButton} 

              sx={{backgroundColor:'#058292 !important'}}>Submit</Button>
          </form>
        </Card>
      </Grid>

      {/* Instant Sale List */}
      <Grid item md={5}>
        <Card sx={{ padding: 2, paddingBottom:'5px',minHeight: '600px' }} className={classes.card}>
          <Typography variant="h6" gutterBottom>Instant Sales List</Typography>
          {instantSales.length === 0 ? (
            <Typography>No instant sales found.</Typography>
          ) : (
<>
            <Grid item lg={12} md={12} sm={12} xs={12}>
            <TableContainer>
              <Table className={classes.table}>
                <TableHead className={classes.tableHeaderRow}>
                  <TableRow >
                  {/* <TableCell className={classes.tablheader}>
                    <CustomCheckbox name="checkbox" />
                      </TableCell>
                    <TableCell className={classes.tablheader}>
                      <Typography variant="subtitle1" color="primary" fontWeight="bold">
                        #
                      </Typography>
                    </TableCell> */}
                    <TableCell className={classes.tablheader}>
                      <Typography variant="subtitle1" color="primary" fontWeight="bold">
                        Product Name
                      </Typography>
                    </TableCell>
                    <TableCell className={classes.tablheader} sx={{ textAlign: "right" }}>
                      <Typography variant="subtitle1" color="primary" fontWeight="bold">
                        Price
                      </Typography>
                    </TableCell>
                    <TableCell className={classes.tablheader} sx={{ textAlign: "right" }}>
                      <Typography variant="subtitle1" color="primary" fontWeight="bold">
                        Date
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {instantSales
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((item: InstantSale, index: any) => (
                      <TableRow key={index} className={classes.tableRowHover}  sx={{ cursor: "pointer", "&:hover": { backgroundColor: "#f5f5f5" } }} // Hover effect
                      onClick={() =>
                        handleAddToCart({
                          id: item.id, 
                          productName: item.product_name, 
                          salePrice: parseFloat(item.price), 
                          productPrice: parseFloat(item.price), 
                          quantity: 1
                        })
                      }>
                        {/* <TableCell className={classes.tablCell}>
                          <CustomCheckbox name="checkbox" />
                         </TableCell>
                        <TableCell className={classes.tablCell}>
                        {page * rowsPerPage + index + 1}
                        </TableCell> */}
                        <TableCell className={classes.tablCell}>
                        <Typography>{item.product_name}</Typography>
                   
                        </TableCell>
                        <TableCell className={classes.tablCell} align="right">
                          <Typography>{item.price}</Typography>
                        </TableCell>
                        <TableCell className={classes.tablCell} align="right">
                        {moment(item.created_at).format("DD-MMM-YY hh:mm A")}
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          </>

            // <ul>
            //   {instantSales.map((sale: InstantSale) => (
            //     <li key={sale.id}>
            //       <strong>{sale.product_name}</strong> - ${sale.price} {sale.hst ? '(HST)' : ''}  
            //       <br /><small>{sale.description}</small>
            //     </li>
            //   ))}
            // </ul>
          )}
        </Card>
      </Grid>
    </Grid>
   ) : showCashForm ? (

    <Grid container spacing={2}   justifyContent="center" >
    <Grid item md={6}>
      <Card sx={{ padding: 2, minHeight: "400px", textAlign: "center" }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
  <Typography variant="h5">
    Cash Entry
  </Typography>
  <Button 
    variant="contained" 
    size="small"
    sx={{ 
      textTransform: "none", 
      height: "35px", 
      minWidth: "100px", 
      backgroundColor: '#f2601f',
      '&:hover': {
        backgroundColor: '#d14e11', // darker shade on hover
      }
    }}
  >
    Due ${change.toFixed(2)}
  </Button>
</Box>


        <TextField fullWidth variant="outlined" value={input} onChange={(e) => setInput(e.target.value)} sx={{
    marginBottom: 2,
    "& .MuiInputBase-input": {
      fontSize: "28px",
      fontWeight: "bold",
    },
  }} />

          <Paper elevation={3} sx={{ padding: 2 }}>
            <Grid container spacing={2}>
              {/* First Row: Preset Amounts */}
              {[10, 20, 50, 100].map((amount) => (
                <Grid item xs={3} key={amount}>
                  <Button size="small"   variant="contained" fullWidth  sx={{ height: "55px", backgroundColor: '#058292', fontSize: "1.0rem" }}  onClick={() => handlePresetAmount(amount)}>
                    ${amount}
                  </Button>
                </Grid>
              ))}

              {/* Second Row: 1, 2, 3, Delete */}
              {[1, 2, 3].map((num) => (
                <Grid item xs={3} key={num}>
                  <Button variant="contained" fullWidth sx={{ height: "55px" }} onClick={() => handleNumberClick(num)}>
                    {num}
                  </Button>
                </Grid>
              ))}
              <Grid item xs={3}>
                <Button variant="contained" color="error" fullWidth sx={{ height: "55px" }} onClick={handleDelete}>
                 X
                </Button>
              </Grid>

              {/* Third Row: 4, 5, 6, Total */}
              {[4, 5, 6].map((num) => (
                <Grid item xs={3} key={num}>
                  <Button variant="contained" fullWidth sx={{ height: "55px" }} onClick={() => handleNumberClick(num)}>
                    {num}
                  </Button>
                </Grid>
              ))}
              <Grid item xs={3}>
                <Button variant="contained"  fullWidth   sx={{ height: "55px", textTransform: "none",backgroundColor: "rgb(0, 150, 80)", }}>
                Total: ${splitPayment ? amount : grandTotal.toFixed(2)}
                </Button>
              </Grid>

              {/* Fourth Row: 7, 8, 9, Amount Paid */}
              {[7, 8, 9].map((num) => (
                <Grid item xs={3} key={num}>
                  <Button variant="contained" fullWidth sx={{ height: "55px" }} onClick={() => handleNumberClick(num)}>
                    {num}
                  </Button>
                </Grid>
              ))}
              <Grid item xs={3}>
                <Button variant="contained"  fullWidth   sx={{ height: "55px", textTransform: "none", backgroundColor: "rgb(0, 150, 80)", }}>
                  Paid ${amountPaid.toFixed(2)}
                </Button>
              </Grid>

              {/* Fifth Row: 0, Enter, Change */}
              <Grid item xs={3}>
                <Button variant="contained" fullWidth sx={{ height: "55px" }} onClick={() => handleNumberClick("0")}>
                  0
                </Button>
              </Grid>
             
              <Grid item xs={3}>
  <Button variant="contained" fullWidth sx={{ height: "55px" }} onClick={() => handleNumberClick(".")}>
    .
  </Button>
</Grid> 


             <Grid item xs={6}>
                <Button variant="contained" color="secondary" fullWidth   sx={{ height: "55px", textTransform: "none", color: 'white' }} onClick={handleEnter}  >
                  Enter
                </Button>
              </Grid>

      

    <Grid item xs={6}>
      <Button variant="contained"
        fullWidth
        sx={{ height: "50px", textTransform: "none", backgroundColor:'#626262 !important',fontWeight: "bold" }}
        onClick={handleOpenCashDrawer}
        disabled={!showActionButtons}
      >
        Open Cash Drawer
      </Button>
    </Grid>
    <Grid item xs={6}>
      <Button variant="contained"
        fullWidth
        sx={{ height: "50px", textTransform: "none", fontWeight: "bold", backgroundColor:'#626262 !important' }}
        onClick={() => handleSaveInvoice("Cash")}
        disabled={!showActionButtons || actionLoading === "Cash"}
      >
        
         {actionLoading === "Cash"? <CircularProgress size={20} /> : "Complete"}
      </Button>
    </Grid>

           
            </Grid>
          </Paper>
        </Card>
      </Grid>
    </Grid>
      
 

  
  ) : showCustomerForm ? (

    <Grid container spacing={2}>
    {/* Form Section */}
    <Grid item md={12} sx={{paddingTop:'10px !important', paddingLeft:'10px !important'}}>
      <Card sx={{ padding: 2 , minHeight:'530px',}} className={classes.card}>
        <Typography variant="h6" style={{marginBottom:'10px'}} gutterBottom>Add Customer</Typography>
        <form onSubmit={formik.handleSubmit}>
        <Grid item lg={12} md={10} sm={12} xs={12} py={2}>
        <Grid container spacing={3}>
            <Grid item lg={12} md={12} sm={12} xs={12} >
              <Card className={classes.card}>
                <Grid
                  container
                  justifyContent={"space-between"}
                  spacing={5}
                  sx={{ borderBottom: 2, padding: 1 }}
                  className={classes.titleGrid}
                >
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    pt={2}
                    alignContent={"center"}
                  >
                    <Typography className={classes.cardTitle}>
                      Add Image
                    </Typography>
                  </Grid>
                </Grid>

                <Grid container spacing={2} p={"24px"}>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Box className={classes.imgBox}>
                      {selectedImage && (
                        <img
                          src={URL.createObjectURL(selectedImage)}
                          alt="Uploaded"
                          className={classes.SelectImageBox}
                        />
                      )}
                      <div>
                        <input
                          accept="image/*"
                          style={{ display: "none" }}
                          id="icon-button-file-1"
                          type="file"
                          onChange={handleImageChange}
                        />
                        <div
                          style={{
                            textAlign: "center",
                          }}
                        >
                          <label htmlFor="icon-button-file-1">
                            <IconButton
                              color="primary"
                              aria-label="upload picture"
                              component="span"
                            >
                              <CloudUploadIcon sx={{ fontSize: 45 }} />
                            </IconButton>
                          </label>
                        </div>
                      </div>
                    </Box>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
            
            

              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card className={classes.card}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 2, padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      pt={2}
                      alignContent={"center"}
                    >
                      <Typography className={classes.cardTitle}>
                        Customer Information
                      </Typography>
                    </Grid>
                  </Grid>

                  <Grid container spacing={3} p={"24px"}>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                            First Name <span style={{ color: "red" }}>*</span>
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <TextField
                            placeholder="Enter First Name"
                            size="small"
                            {...formik.getFieldProps("customerFirstName")}
                            className={classes.textField}
                            InputProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                            Last Name <span style={{ color: "red" }}>*</span>

                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <TextField
                            placeholder="Enter Last Name"
                            size="small"
                            {...formik.getFieldProps("customerLastName")}
                            className={classes.textField}
                            InputProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                            Mobile Number <span style={{ color: "red" }}>*</span>
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <TextField
                            placeholder="Enter Mobile Number"
                            size="small"
                            {...formik.getFieldProps("customerMobileNum")}
                            className={classes.textField}
                            InputProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                            error={
                              formik.touched.customerMobileNum &&
                              Boolean(formik.errors.customerMobileNum)
                            }
                            helperText={
                              formik.touched.customerMobileNum &&
                              formik.errors.customerMobileNum
                            }
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">E-mail <span style={{ color: "red" }}>*</span></Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <TextField
                            placeholder="Enter E-mail"
                            size="small"
                            type="email"
                            {...formik.getFieldProps("customerEmail")}
                            className={classes.textField}
                            InputProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                            error={
                              formik.touched.customerEmail &&
                              Boolean(formik.errors.customerEmail)
                            }
                            helperText={
                              formik.touched.customerEmail &&
                              formik.errors.customerEmail
                            }
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                   
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">Prefer Time to call</Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <TextField
                            placeholder="Enter Prefer Time to call"
                            size="small"
                            {...formik.getFieldProps("customerPreferTimeToCall")}
                            className={classes.textField}
                            InputProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                   
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                            Description
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <TextField
                            placeholder="Enter Description .."
                            size="small"
                            multiline
                            rows={8}
                            {...formik.getFieldProps("customerDescription")}
                            className={classes.discriptionTextField}
                            InputProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>

 <Grid item lg={12} md={12} sm={12} xs={12}>
              <Card className={classes.card}>
                <Grid
                  container
                  justifyContent={"space-between"}
                  spacing={5}
                  sx={{ borderBottom: 2, padding: 2 }}
                  className={classes.titleGrid}
                >
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    pt={2}
                    alignContent={"center"}
                  >
                    <Typography className={classes.cardTitle}>
                      Address
                    </Typography>
                  </Grid>
                </Grid>

                <Grid container spacing={3} p={"24px"}>

                <Grid item lg={6} md={6} sm={12} xs={12}>
                    <Grid container alignItems="center">
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography variant="subtitle1">
                           Street No.
                        </Typography>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <TextField
                          placeholder="Enter Street No."
                          size="small"
                          {...formik.getFieldProps("customerStreetNumber")}
                          className={classes.textField}
                          InputProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                          InputLabelProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <Grid container alignItems="center">
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography variant="subtitle1">
                           Street Name
                        </Typography>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <TextField
                          placeholder="Enter Street Name"
                          size="small"
                          {...formik.getFieldProps("customerStreetName")}
                          className={classes.textField}
                          InputProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                          InputLabelProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <Grid container alignItems="center">
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography variant="subtitle1">
                           City
                        </Typography>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <TextField
                          placeholder="Enter City"
                          size="small"
                          {...formik.getFieldProps("customerCity")}
                          className={classes.textField}
                          InputProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                          InputLabelProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <Grid container alignItems="center">
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography variant="subtitle1">
                           Province
                        </Typography>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <TextField
                          placeholder="Enter Province"
                          size="small"
                          {...formik.getFieldProps("customerProvince")}
                          className={classes.textField}
                          InputProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                          InputLabelProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <Grid container alignItems="center">
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography variant="subtitle1">
                           Postal Code
                        </Typography>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <TextField
                          placeholder="Enter Postal Code"
                          size="small"
                          {...formik.getFieldProps("customerPostalCode")}
                          className={classes.textField}
                          InputProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                          InputLabelProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                 
                </Grid>
              </Card>
            </Grid>

              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card className={classes.card}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 2, padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      pt={2}
                      alignContent={"center"}
                    >
                      <Typography className={classes.cardTitle}>
                     Company Information{" "}
  <span style={{ fontSize: "0.75rem", color: "#888", fontWeight: 400 }}>
    (Optional)
  </span>
                      </Typography>
                    </Grid>
                  </Grid>

                  <Grid container spacing={3} p={"24px"}>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                            Company Name
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <TextField
                            placeholder="Enter Company Name"
                            size="small"
                            {...formik.getFieldProps("customerCompanyName")}
                            className={classes.textField}
                            InputProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">Company Phone Number</Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <TextField
                            placeholder="Enter Company Phone Number"
                            size="small"
                            {...formik.getFieldProps("customerCompanyPhoneNumebr")}
                            className={classes.textField}
                            InputProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                            error={
                              formik.touched.customerCompanyPhoneNumebr &&
                              Boolean(formik.errors.customerCompanyPhoneNumebr)
                            }
                            helperText={
                              formik.touched.customerCompanyPhoneNumebr &&
                              formik.errors.customerCompanyPhoneNumebr
                            }
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                            E-mail
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <TextField
                            placeholder="Enter E-mail"
                            size="small"
                            {...formik.getFieldProps("customerCompanyEmail")}
                            className={classes.textField}
                            InputProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                            error={
                              formik.touched.customerCompanyEmail &&
                              Boolean(formik.errors.customerCompanyEmail)
                            }
                            helperText={
                              formik.touched.customerCompanyEmail &&
                              formik.errors.customerCompanyEmail
                            }
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>

              

              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card className={classes.card}>
                  <Grid container spacing={3} p={"24px"}>
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <Button
                        variant="outlined"
                        startIcon={<CloseIcon />}
                        className={classes.addButton}
                        onClick={cancelFunction}
                      >
                        Cancel
                      </Button>
                      <Box m={0.5}></Box>

                      <Button
                        variant="contained"
                        startIcon={<SaveAltIcon />}
                        className={classes.addButton}
                        onClick={() => formik.handleSubmit()}
                        disabled={!formValid || isLoading}
                      >
                        Save
                      </Button>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            </Grid>
              </Grid>
        </form>
      </Card>
    </Grid>

    
  </Grid>


) : showDiscountForm ? (

  <Grid container spacing={2}>
  {/* Form Section */}
  <Grid item md={12} sx={{paddingTop:'10px !important', paddingLeft:'10px !important'}}>
    <Card sx={{ padding: 2 , minHeight:'530px',}} className={classes.card}>
      <Typography variant="h6" style={{marginBottom:'10px'}} gutterBottom>Add Discount</Typography>
      <form onSubmit={formik.handleSubmit}>
      <Grid item lg={12} md={10} sm={12} xs={12} py={2}>
      <Grid container spacing={3}>
          
           <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Grid container alignItems="center">
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Typography variant="subtitle1">Discount :</Typography>
                                </Grid>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <TextField
                                    placeholder="Enter discount value :"
                                    size="small"
                                    value={discountValue}
                                    onChange={(e) =>
                                      setDiscountValue(Number(e.target.value))
                                    }
                                    className={classes.textField}
                                    InputProps={{
                                      sx: {
                                        fontSize: 14,
                                      },
                                      startAdornment: (
                                        <InputAdornment position="start">
                                          $
                                        </InputAdornment>
                                      ),
                                    }}
                                    InputLabelProps={{
                                      sx: {
                                        fontSize: 14,
                                      },
                                    }}
                                  />
                                </Grid>
                              </Grid>
                            </Grid>

           <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Grid container alignItems="center">
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Typography variant="subtitle1">
                                    Description :
                                  </Typography>
                                </Grid>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <TextField
                                    placeholder="Enter Description .."
                                    size="small"
                                    multiline
                                    rows={8}
                                    value={discountDescription}
                                    onChange={(e) =>
                                      setDiscountDescription(e.target.value)
                                    }
                                    className={classes.discriptionTextField}
                                    InputProps={{
                                      sx: {
                                        fontSize: 14,
                                      },
                                    }}
                                    InputLabelProps={{
                                      sx: {
                                        fontSize: 14,
                                      },
                                    }}
                                  />
                                </Grid>
                              </Grid>
                            </Grid>

            

            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Card className={classes.card}>
                <Grid container spacing={3} p={"24px"}>
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    sx={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <Button
                      variant="outlined"
                      startIcon={<CloseIcon />}
                      className={classes.addButton}
                      onClick={cancelDiscountFunction}
                    >
                      Cancel
                    </Button>
                    <Box m={0.5}></Box>

                    <Button
                    variant="contained"
                    startIcon={<SaveAltIcon />}
                    className={classes.addButton}
                    onClick={handleSaveDiscount}>
                    Save
                    </Button>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </Grid>
            </Grid>
      </form>
    </Card>
  </Grid>

  
</Grid>

) : showSplitForm ? (

  <Grid container spacing={2}>
  {/* Form Section */}
  <Grid item md={5} sx={{paddingTop:'10px !important', paddingLeft:'10px !important'}}>
  <Card sx={{ padding: 2, paddingBottom:'5px',minHeight: '530px' }} className={classes.card}>
          <Typography variant="h6" gutterBottom>Split Payment</Typography>
          <Grid item lg={12} md={10} sm={12} xs={12} py={2}>
          <Grid container spacing={3}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Grid container alignItems="center">
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Typography variant="subtitle1">Total Amount :</Typography>
                                </Grid>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <TextField
                                    size="small"
                                    value={grandTotal}
                                    className={classes.textField}
                                    InputProps={{
                                      readOnly: true,
                                      sx: {
                                        fontSize: 14,
                                      },
                                      startAdornment: (
                                        <InputAdornment position="start">
                                          $
                                        </InputAdornment>
                                      ),
                                    }}
                                    InputLabelProps={{
                                      sx: {
                                        fontSize: 14,
                                      },
                                    }}
                                  />
                                </Grid>
                              </Grid>
                            </Grid>
                            </Grid>
                            </Grid>
     </Card>
  </Grid>



  <Grid item md={7} sx={{paddingTop:'10px !important', paddingLeft:'10px !important'}}>
  <Card sx={{ padding: 2 , minHeight:'530px',}} className={classes.card}>
      <Typography variant="h6" style={{marginBottom:'10px'}} gutterBottom>Split Payment</Typography>
      <form onSubmit={formik.handleSubmit}>
      <Grid item lg={12} md={10} sm={12} xs={12} py={2}>
      <Grid container spacing={3}>
          
           <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Grid container alignItems="center">
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Typography variant="subtitle1">Paid Amount :</Typography>
                                </Grid>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <TextField
                                    size="small"
                                    value={amtPaid}
                                    className={classes.textField}
                                    InputProps={{
                                      readOnly: true,
                                      sx: {
                                        fontSize: 14,
                                      },
                                      startAdornment: (
                                        <InputAdornment position="start">
                                          $
                                        </InputAdornment>
                                      ),
                                    }}
                                    InputLabelProps={{
                                      sx: {
                                        fontSize: 14,
                                      },
                                    }}
                                  />
                                </Grid>
                              </Grid>
                            </Grid>

                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Grid container alignItems="center">
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Typography variant="subtitle1">Amount to be Paid <span style={{ color: "red" }}>*</span> :</Typography>
                                </Grid>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <TextField
                                    size="small"
                                    value={amount}
                                    className={classes.textField}
                                    onChange={(e) =>
                                      setAmount(e.target.value)
                                    }
                                    InputProps={{
                                      sx: {
                                        fontSize: 14,
                                      },
                                      startAdornment: (
                                        <InputAdornment position="start">
                                          $
                                        </InputAdornment>
                                      ),
                                    }}
                                    InputLabelProps={{
                                      sx: {
                                        fontSize: 14,
                                      },
                                    }}
                                  />
                                </Grid>
                              </Grid>
                            </Grid>

                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Grid container alignItems="center">
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Typography variant="subtitle1">Mode: </Typography>
                                </Grid>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                       <Box  display="flex" justifyContent="space-between"  flexWrap="wrap" gap={0.5} p={1}>
                            <Button
    size="small"
  //  className={classes.SalesAddButton}
    variant="contained"
    sx={{
      flex: "1 1 18%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: '#058292 !important',
      textTransform: "none",
      paddingTop: '5px !important',
      paddingBottom: '5px !important',
      boxShadow:'none',
    }}
     disabled={Number(amount) <= 0}
    onClick={() => {
      setSplitPayment(true);
      handleShowCashForm();
    }}
    
  >
    <MoneyIcon fontSize="medium" />
    <Typography variant="body2" fontWeight="bold" >Cash</Typography>
  </Button>


  <Button
    size="small"
   // className={classes.SalesAddButton}
    variant="contained"
    sx={{
      flex: "1 1 18%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: '#058292 !important',
      textTransform: "none",
      paddingTop: '5px !important',
      paddingBottom: '5px !important',
      boxShadow:'none',
    }}
     disabled={Number(amount) <= 0}
     onClick={() => {
    setSplitPayment(true);
    handleSaveInvoice("Credit");
  }}
  >
    <CreditCardIcon fontSize="medium" />
    <Typography variant="body2" fontWeight="bold">Credit</Typography>
  </Button>

  <Button
    size="small"
   // className={classes.SalesAddButton}
    variant="contained"
    sx={{
      flex: "1 1 18%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: '#058292 !important',
      textTransform: "none",
      paddingTop: '2px !important',
      paddingBottom: '2px !important',
      boxShadow:'none',
    }}
     disabled={Number(amount) <= 0}
    onClick={() => {
    setSplitPayment(true);
    handleSaveInvoice("Debit");
  }}
  >
    <PaymentIcon fontSize="medium" />
    <Typography variant="body2" fontWeight="bold">Debit</Typography>
  </Button>
  </Box>

  </Grid>
                              </Grid>
                            </Grid>
            

            {/* <Grid item lg={12} md={12} sm={12} xs={12}>
              <Card className={classes.card}>
                <Grid container spacing={3} p={"24px"}>
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    sx={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <Button
                      variant="outlined"
                      startIcon={<CloseIcon />}
                      className={classes.addButton}
                      onClick={cancelDiscountFunction}
                    >
                      Cancel
                    </Button>
                    <Box m={0.5}></Box>

                    <Button
                    variant="contained"
                    startIcon={<SaveAltIcon />}
                    className={classes.addButton}
                    onClick={handleSaveDiscount}>
                    Pay
                    </Button>
                  </Grid>
                </Grid>
              </Card>
            </Grid> */}
          </Grid>
            </Grid>
      </form>


      {/* <Grid container spacing={2} mb={2} mt={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Total Amount"
            fullWidth
            value={totalAmount.toFixed(2)}
            InputProps={{
              readOnly: true,
              startAdornment: <InputAdornment position="start">$</InputAdornment>,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Remaining"
            fullWidth
            value={remaining.toFixed(2)}
            InputProps={{
              readOnly: true,
              startAdornment: <InputAdornment position="start">$</InputAdornment>,
            }}
          />
        </Grid>
      </Grid>

      <Grid container spacing={2} alignItems="center" mb={2}>
        <Grid item xs={5}>
          <TextField
            select
            label="Payment Method"
            value={method}
            onChange={(e) => setMethod(e.target.value)}
            fullWidth
          >
          {paymentMethods.map((option: string) => (
  <MenuItem key={option} value={option}>
    {option}
  </MenuItem>
))}

          </TextField>
        </Grid>

        <Grid item xs={4}>
          <TextField
            label="Amount"
            type="number"
            fullWidth
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            InputProps={{
              startAdornment: <InputAdornment position="start">$</InputAdornment>,
            }}
          />
        </Grid>

        <Grid item xs={3}>
          <Button
            variant="contained"
            fullWidth
            onClick={handleAddPayment}
            disabled={!amount || Number(amount) <= 0}
          >
            Add
          </Button>
        </Grid>
      </Grid>

      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Method</TableCell>
            <TableCell>Amount ($)</TableCell>
            <TableCell align="right">Remove</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {payments.map((payment, index) => (
            <TableRow key={index}>
              <TableCell>{payment.method}</TableCell>
              <TableCell>{payment.amount.toFixed(2)}</TableCell>
              <TableCell align="right">
                <Button
                  variant="outlined"
                  color="error"
                  size="small"
                  onClick={() => handleRemove(index)}
                >
                  Remove
                </Button>
              </TableCell>
            </TableRow>
          ))}
          {payments.length === 0 && (
            <TableRow>
              <TableCell colSpan={3} align="center">
                No split payments added.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>

      <Box mt={3} display="flex" justifyContent="flex-end">
        <Button
          variant="contained"
          color="success"
          disabled={remaining > 0}
          onClick={handleCompletePayment}
        >
          Complete Payment
        </Button>
      </Box> */}



    </Card>
     
     
       
</Grid>
  
</Grid>
   
    ) :(

    // Default Product Grid
    <Box display="flex" justifyContent="center" alignItems="center">
    {loading ? (
      <CircularProgress />
    ) : !showingVariants ? (
    variantDetails.length === 0 ? (
      <Typography>No items available</Typography>
    ) : (
      <Grid container spacing={2}>



<Grid item lg={12} md={12} sm={12} xs={12} sx={{ display: "flex"}} >
   <Grid container spacing={2}> 
    {/* Subcategories */} 
    {selectedCategoryId && subCategoryList?.map((subCat: any) => ( <Grid item key={subCat.id}> 
      <Button className={classes.SalesAddButton} variant="outlined" sx={{ backgroundColor: "#058292", color: "#ffffff", "&:hover": { backgroundColor: "#04626b" }, minWidth: "120px", }} 
      onClick={() => handleSubCategoryChange(subCat.id)} > {subCat.categoryName} 
      </Button> 
      </Grid> ))}
      {/* Sub-to-sub categories */} 
      {selectedCategoryId && subToSubCategoryList ?.filter(sub => sub.parent_ids?.includes(selectedSubCategoryId!)) .map((subCat: any) => (
         <Grid item key={subCat.id}> 
         <Button className={classes.SalesAddButton} variant="outlined"
          sx={{ backgroundColor: "#058292", color: "#ffffff", "&:hover": { backgroundColor: "#04626b" }, minWidth: "120px", }}
           onClick={() => handleSubToSubCategoryChange(subCat.id)} > {subCat.categoryName} 
           </Button>
            </Grid>
           ))}
           {/* Sub-to-sub-to-sub categories */} 
           {selectedCategoryId && selectedSubCategoryId && 
           subToSubToSubCategoryList ?.filter(sub => sub.parent_ids?.includes(selectedSubToSubCategoryId!)) .map((subCat: any) => ( 
           <Grid item key={subCat.id}> 
           <Button className={classes.SalesAddButton} variant="outlined" 
           sx={{ backgroundColor: "#058292", color: "#ffffff", "&:hover": { backgroundColor: "#04626b" }, minWidth: "120px", }} 
           onClick={() => handleSubToSubToSubCategoryChange(subCat.id)} > {subCat.categoryName} 
           </Button> 
           </Grid>
           ))} 
           </Grid> 
           </Grid>

           


        {variantDetails
         .sort((a, b) => Number(a.orderNumber ?? 0) - Number(b.orderNumber ?? 0))
        .map((item, index) => {
            const isSelected = cartItems.some(cart => cart.type === 'product' && cart.id === Number(item.id));
            const discountPercentage = item.salePrice
            ? Math.round(((Number(item.productPrice) - Number(item.salePrice)) / Number(item.productPrice)) * 100)
            : 0;
            const sortedModifierGroups = [...(item.modifierGroups || [])];
const linkedIds: number[] = item.linkedProductId ? JSON.parse(item.linkedProductId) : [];
// Sort modifier groups with order set, keep those with null order in original positions
sortedModifierGroups.sort((a, b) => {
  if (a.order != null && b.order != null) {
    return a.order - b.order;
  }
  if (a.order != null) {
    return -1; // a before b
  }
  if (b.order != null) {
    return 1;  // b before a
  }
  return 0;    // both null, keep original order
});

            return (

              <Grid
                item
                key={item.id}
                xs={6}
                sm={4}
                md={3}
                lg={2.4}
                sx={{ paddingTop: '10px !important', paddingLeft: '10px !important' }}
                data-aos="fade-down"
                data-aos-delay={`${index * 100}`}
              >
                  <Card
                    // className={classes.card}
                    style={{ cursor: 'pointer' }}
                    // onClick={() => handleAddToCart(item)}
                    onClick={() => {
                       if (item.isSerialize) {
                    
   setSelectedSerialProducts(item.serialized_items || []);
    setShowSerialPopup(true);
  }
                    else  if (item.hasVariants) {
                        const filteredVariants = variantList.filter(v => v.productId === item.id);
                        setSelectedVariantProduct(filteredVariants);
                        setShowingVariants(true);
                      } else {
                        onProductSelect(item, 'product');
                      }
                    } }
                    sx={{
                      cursor: 'pointer',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      border: isSelected ? '1.5px solid #fabfa5' : 'none',
                      position: 'relative',
                      paddingTop: '5px',
                      paddingBottom: '5px',
                      boxShadow: "0 0 0 0.15rem rgba(var(--bs-btn-focus-shadow-rgb), .5)",
                      //boxShadow: isSelected ? '0 0 10px rgba(242, 96, 31, 0.4)' : 'none',
                      //transition: 'border 0.3s ease, box-shadow 0.3s ease',
                    }}
                  >
                    {isSelected && (
                      <Box
                        sx={{
                          position: 'absolute',
                          top: 8,
                          left: 8,
                          backgroundColor: '#fff',
                          borderRadius: '50%',
                          padding: '2px',
                          zIndex: 2,
                        }}
                      >
                        <CheckCircleIcon sx={{ color: '#058292', fontSize: 22 }} />
                      </Box>
                    )}

                    {/* {item.salePrice > 0 && (
              <Box
                sx={{
                  position: "absolute",
                  top: 8,
                  right: 8,
                  backgroundColor: "#f2601f",
                  color: "#fff",
                  fontSize: "12px",
                  fontWeight: "bold",
                  padding: "5px 8px",
                 
        clipPath: "polygon(0% 0%, 20% 0%, 30% 20%, 50% 0%, 70% 20%, 80% 0%, 100% 0%, 100% 20%, 80% 40%, 100% 60%, 100% 80%, 80% 100%, 70% 80%, 50% 100%, 30% 80%, 20% 100%, 0% 80%, 0% 60%, 20% 40%)", // Zigzag effect on part of the circle
      
                }}
              >
                {discountPercentage}%
              </Box>
            )} */}

                    <Box
                      sx={{
                        width: '100%',
                        height: '120px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        overflow: 'hidden',
                      }}
                    >
                      <img
                     
                        src={item.productImg?`${LARAVEL_API_URL}/${item.productImg}` : placeholderImage}
                        alt={item.productName}
                        style={{
                          width: '100%',
                          height: '80%',
                          objectFit: 'contain'
                        }} />
                    </Box>
                    <Box sx={{ padding: '2px 8px 10px 8px', marginTop: '-8px', textAlign: 'center', width: '100%' }}>
                      <Typography variant="subtitle1" noWrap style={{ fontWeight: 'bold', marginBottom: '0px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {item.productName}
                      </Typography>

                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: "500",
                          marginBottom: "0px",
                          fontSize: "14px",
                        }}
                      >
                        {/* {!item.hasVariants ? (
  item.salePrice ? (
    <span style={{ color: "#f2601f" }}>${item.salePrice}</span>
  ) : (
    <span style={{ color: "#f2601f" }}>$0.00</span>
  )
) : (
  <span style={{ visibility: "hidden" }}>$0.00</span>
)} */}

                        {!item.hasVariants ? (
                          item.offerPrice ? (
                            <>
                              <span
                                style={{
                                  textDecoration: "line-through",
                                  marginRight: "5px",
                                }}
                              >
                                ${item.salePrice}
                              </span>
                              <span style={{ color: "#f2601f" }}>${item.offerPrice}</span>
                            </>
                          ) : (
                            <span style={{ color: "#f2601f" }}>${item.salePrice}</span>
                          )
                        ) : (

                          <span style={{ visibility: "hidden" }}>$0.00</span>
                        )}
                      </Typography>

                      {/* Modifier Summary Line */}
                      {/* <Box mt={0} minHeight="20px">
                        {item.modifierGroups && item.modifierGroups.length > 0 ? (
                          <Typography
                            variant="caption"
                            sx={{ color: "#777", cursor: "pointer" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              setExpandedModifiers({ open: true, product: item });
                              //console.log(item.modifierGroups)
                            } }
                          >
                            + {item.modifierGroups.length} {item.modifierGroups.length === 1 ? 'Modifier' : 'Modifiers'}
                          </Typography>
                        ) : (
                          <Typography variant="caption" sx={{ visibility: "hidden" }}>
                            + 0 modifier
                          </Typography>
                        )}
                      </Box> */}

                       <Box mt={0} minHeight="20px">
  {item.modifierGroupId && item.modifierGroupId.length > 0 ? (
    <Typography
      variant="caption"
      sx={{ color: "#777", cursor: "pointer" }}
      onClick={(e) => {
        e.stopPropagation();
        setExpandedModifiers({ open: true, product: item });
      }}
    >
      + {item.modifierGroupId.length}{" "}
      {item.modifierGroupId.length === 1 ? "Modifier" : "Modifiers"}
    </Typography>
  ) : (
    <Typography variant="caption" sx={{ visibility: "hidden" }}>
      + 0 modifier
    </Typography>
  )}
</Box>


                      <Box mt={0} minHeight="20px">
                        {linkedIds && linkedIds.length > 0 ? (
                          <Typography
                            variant="caption"
                            sx={{ color: "#777", cursor: "pointer" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              setExpandedLinks({ open: true, product: item });
                              //console.log(item.modifierGroups)
                            } }
                          >
                            + {linkedIds.length} {linkedIds.length === 1 ? 'Link' : 'Links'}
                          </Typography>
                        ) : (
                          <Typography variant="caption" sx={{ visibility: "hidden" }}>
                            + 0 link
                          </Typography>
                        )}
                      </Box>

                    </Box>
                  </Card>
                </Grid>
)})}

      </Grid>
    )
 ) : (
  
  selectedVariantProduct && selectedVariantProduct.length > 0 && (
  <>
    {/* <Typography variant="h6" sx={{ mt: 4, mb: 2 }}>
      Variants of {selectedVariantProduct[0].productName}
    </Typography> */}

    <Grid container spacing={2}>
      {selectedVariantProduct
      .slice() .sort((a, b) => 
    (Number(a.orderNumber) || 0) - (Number(b.orderNumber) || 0))
    .map((variant, index) => {
        const isSelected = cartItems.some(cart =>  cart.type === 'variant' && cart.id === Number(variant.id));
        const discountPercentage = variant.salePrice
          ? Math.round(((Number(variant.productPrice) - Number(variant.salePrice)) / Number(variant.productPrice)) * 100)
          : 0;

        return (
          <Grid
            item
            key={variant.id}
            xs={6}
            sm={4}
            md={3}
            lg={2.4}
            sx={{ paddingTop: '10px !important', paddingLeft: '10px !important' }}
            data-aos="fade-down"
            data-aos-delay={`${index * 100}`} 
         >
            <Card
              onClick={() => onProductSelect(variant, 'variant')}
              sx={{
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                border: isSelected ? '1.5px solid #fabfa5' : 'none',
                position: 'relative',
                paddingTop: '5px',
                paddingBottom: '5px',
                boxShadow: "0 0 0 0.15rem rgba(var(--bs-btn-focus-shadow-rgb), .5)",
              }}
            >
              {isSelected && (
                <Box
                  sx={{
                    position: 'absolute',
                    top: 8,
                    left: 8,
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    padding: '2px',
                    zIndex: 2,
                  }}
                >
                  <CheckCircleIcon sx={{ color: '#058292', fontSize: 22 }} />
                </Box>
              )}

              <Box
                sx={{
                  width: '100%',
                  height: '120px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  overflow: 'hidden',
                }}
              >
                <img
                  src={variant.productImg?`${LARAVEL_API_URL}/${variant.productImg}` : placeholderImage}
                  alt={variant.productName}
                  style={{
                    width: '100%',
                    height: '80%',
                    objectFit: 'contain',
                  }}
                />
              </Box>

              <Box sx={{ padding: '2px 8px 10px 8px', marginTop: '-8px', textAlign: 'center', width: '100%' }}>
                <Typography variant="subtitle1" noWrap sx={{ fontWeight: 'bold' }}>
                  {variant.productName}
                </Typography>

                  <Typography
    variant="subtitle2"
    sx={{
      fontWeight: "500",
      marginBottom: "0px",
      fontSize: "14px",
    }}
  >
     {variant.offerPrice ? (
      <>
        <span
          style={{
          
            textDecoration: "line-through",
            marginRight: "5px",
          }}
        >
          ${variant.salePrice}
        </span>
        <span style={{ color: "#f2601f" }}>${variant.offerPrice}</span>
      </>
    ) : (
      <span style={{ color: "#f2601f" }}>${variant.salePrice}</span>
    )}
  
  </Typography>

                {/* Add modifierGroups line or other details here if needed */}
              </Box>
            </Card>
          </Grid>
        );
      })}
    </Grid>
  </>
))
  }
  </Box>
  )}






</Grid>

</Grid>


   
      </Grid>





      <Grid item xs={12} sm={6} md={3} style={{paddingTop:'10px !important'}}> 
     

  
      <Grid item xs={12} >
      <Card className={classes.card} >
      <Grid
        container
        spacing={5}
        sx={{ padding: 1 }}

        className={classes.titleGrid}
      >
      
          {/* <Typography className={classes.cardTitle}></Typography> */}
          <Grid item xs={12} sm={6} md={4}>
        <Button
          variant="contained"
          // startIcon={<LocalPrintshopSharpIcon />}
          className={classes.SalesAddButton}
          sx={{
            backgroundColor: '#fdcb5f !important',
            color: '#3c3c3c', // Reduce black color intensity
            '&:hover': { backgroundColor: '#f39c12' }, // Remove hover effect
          }}
          onClick={handleWalkIn}
        >
           Walk in
        </Button>
        </Grid>
       
        <Grid item xs={12} sm={6} md={7} sx={{ paddingLeft: '12px !important' }}>
        <Autocomplete
    options={customerList}
    getOptionLabel={(option) => {
      if (typeof option === 'string') return option;
      return `${option.customerFirstName} ${option.customerLastName}`;
    }}
    filterOptions={filterOptions}
    value={selectedCustomer || null}
    onChange={(event, newValue) => {
      if (typeof newValue === 'object' && newValue !== null) {
        setSelectedCustomer(newValue);
        setSearchQueryCustomer(`${newValue.customerFirstName} ${newValue.customerLastName}`);
      } else if (typeof newValue === 'string') {
        setSearchQueryCustomer(newValue);
        setSelectedCustomer(null);
      }
    }}
    onInputChange={(event, newInputValue) => {
      setSearchQueryCustomer(newInputValue);
      if (newInputValue === '') {
        setSelectedCustomer(null);
      }
    }}
    renderInput={(params) => (
      <TextField
        {...params}
        value={searchQueryCustomer}
        onChange={(e) => setSearchQueryCustomer(e.target.value)}
        placeholder="Search Customer"
        size="small"
        InputProps={{
          ...params.InputProps,
          startAdornment: (
            <InputAdornment position="start">
              <Box sx={{ pr: 2 }}>
                <CiSearch className={classes.searchWidgetIcon} />
              </Box>
            </InputAdornment>
          ),
          classes: {
            root: classes.SalesformControlList,
          },
        }}
        sx={{
          width: "100%",
          border: 'none !important',
          color: 'theme.palette.primary.main',
        }}
      />
    )}
  />



              {/* <TextField
           
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CiSearch className={classes.searchWidgetIcon} />
                    </InputAdornment>
                  ),
                  classes: {
                    root: classes.SalesformControlList,
                  },
                }}
       
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Search Customer"
                sx={{ width: "100%",
                  // '& .MuiOutlinedInput-root': {
                  //   height: '34px',
                  //   paddingLeft: '40px',
                  //   paddingRight: '15px',
                  //   boxShadow: 'none',
                    border: 'none !important', 
                    color: 'theme.palette.primary.main'
                  //   backgroundColor: '#eaf4f3'
                  // },
                }}
                size="small"
              
              /> */}
            </Grid>

            <Grid item xs={12} sm={6} md={1} sx={{ paddingLeft:'5px !important'}}>
        <Button
          variant="contained"
          // startIcon={<LocalPrintshopSharpIcon />}
          className={classes.SalesAddButton}
          sx={{
            minWidth: '30px',
            height: '33px',
            padding: '0',
            fontSize: '16px',
            lineHeight: 1,
            backgroundColor:'#626262 !important',
          }}
          onClick={handleShowCustomerForm} 
        >
            <AddIcon style={{fontSize:'18px'}}/>
        </Button>
        </Grid>
            
          </Grid>

      </Card>
      </Grid>



      {selectedCustomer ? (
  <Grid item xs={12} mt={1}>
    <Card className={classes.card}>
      <Grid container spacing={1} sx={{ padding: 2 }}>
        {/* Column 1: Customer Info */}
        <Grid item xs={6}>
          <Grid container direction="column" spacing={1}>
            <Grid item>
              <Typography>{`${selectedCustomer.customerFirstName} ${selectedCustomer.customerLastName}`}</Typography>
              <Typography>{selectedCustomer.customerMobileNum}</Typography>
              <Typography>{selectedCustomer.customerEmail}</Typography>
            </Grid>
          </Grid>
        </Grid>

        {/* Column 2: Package Details */}
        <Grid item xs={3}>
          <Grid container direction="column" spacing={1}>
            <Grid item>
              <Typography>Silver</Typography>
              <Typography>20/5000</Typography>
            </Grid>
          </Grid>
        </Grid>

        {/* Column 3: Last Visit Details */}
        <Grid item xs={3}>
          <Grid container direction="column" spacing={1}>
            <Grid item>
              <Typography>Last Visit</Typography>
              <Typography>20/03/2025</Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Card>
  </Grid>
) : (
  
  <Grid item xs={12} mt={1}>
    <Card className={classes.card}>
      <Grid container spacing={1} sx={{ padding: 2 }}>
        {/* Column 1: Customer Info */}
        <Grid item xs={6}>
          <Grid container direction="column" spacing={1}>
            <Grid item>
              <Typography style={{visibility:'hidden'}}>name</Typography>
              <Typography>Please select a customer</Typography>
              <Typography style={{visibility:'hidden'}} >email</Typography>
            </Grid>
          </Grid>
        </Grid>

        {/* Column 2: Package Details */}
        <Grid item xs={3}>
          <Grid container direction="column" spacing={1}>
            <Grid item>
              {/* Empty for Walk in */}
            </Grid>
          </Grid>
        </Grid>

        {/* Column 3: Last Visit Details */}
        <Grid item xs={3}>
          <Grid container direction="column" spacing={1}>
            <Grid item>
              {/* Empty for Walk in */}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Card>
  </Grid>
)}







      {/* {cartItems.length > 0 && ( */}

 <Card className={classes.stepperCard} sx={{ minHeight: '418px', position: 'relative', display: 'flex', flexDirection: 'column', marginTop: '8px' }}>
    
 
          <TableContainer >
            <Table className={classes.table}>
              <TableHead className={classes.tableHeaderRow}>
                <TableRow>
                 
                  <TableCell className={classes.tablheader}  sx={{ color: 'primary.main'}}>
                                               <strong>Items</strong>
                                             </TableCell>
                                              <TableCell className={classes.tablheader}  sx={{ color: 'primary.main'}}>
                                               <strong>Qty</strong>
                                             </TableCell>
                                              <TableCell className={classes.tablheader}  sx={{ color: 'primary.main', textAlign: "right" }}>
                                               <strong>Rate</strong>
                                             </TableCell>
                 
                </TableRow>
              </TableHead>
              <TableBody>
                {cartItems
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item: any, index: any) => (
                    <TableRow key={index} className={classes.tableRowHover}>
                      <TableCell className={classes.tablCell} sx={{ width: '60%' }}>
                        <Typography>{item.productName}</Typography>

 {/* {item.selectedDate  && item.slotTimes &&  ( */}
            <Box mt={0.5}>
              {item.selectedDate && (
                <Typography variant="body2" color="textSecondary">
                  📅 {item.selectedDate}
                </Typography>
              )}
              {item.slotTimes && item.slotTimes.length > 0 && (
                <Box display="flex" flexWrap="wrap" gap={0.5} mt={0.5}>
  {item.slotTimes.map((slot: string, index: number) => {
    const [start, end] = slot.split("-");
    const formatTime = (time: string) =>
      new Date(`1970-01-01T${time}`).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      });

    return (
      <Chip
        key={index}
        size="small"
        label={`${formatTime(start)} – ${formatTime(end)}`}
      />
    );
  })}
</Box>
              )}
            </Box>
          {/* )} */}

                      </TableCell>
                      <TableCell className={classes.tablCell}>
                        <Box display="flex" alignItems="center">
                          <Button
                            size="small"
                            sx={{
                              minWidth: '24px',
                              height: '24px',
                              padding: '0',
                              fontSize: '14px',
                              lineHeight: 1,
                              backgroundColor : '#058292 !important',
                              boxShadow:'none',
                            }}
                            variant="contained"
                            onClick={() => updateQuantity(item.id, -1)}
                            disabled={item.quantity <= 1}
                          >
                            -
                          </Button>
                          <Typography mx={1}>{item.quantity}</Typography>
                          <Button
                            size="small"
                            sx={{
                              minWidth: '24px',
                              height: '24px',
                              padding: '0',
                              fontSize: '14px',
                              lineHeight: 1,
                              backgroundColor : '#058292 !important',
                              boxShadow:'none',
                            }}
                            variant="contained"
                            onClick={() => updateQuantity(item.id, 1)}
                          >
                            +
                          </Button>
                        </Box>
                      </TableCell>
                      <TableCell className={classes.tablCell} align="right">
                      <Typography>
                      {/* { item.offerPrice ? (
    ((item.offerPrice * item.quantity) || 0).toFixed(2)
  ) : (
    ((item.salePrice * item.quantity) || 0).toFixed(2)
  )
} */}

 {calculateItemTotal(item).toFixed(2)}

  {/* {item.salePrice > 0
    ? (item.salePrice * item.quantity).toFixed(2)
    : (item.productPrice * item.quantity).toFixed(2)} */}
</Typography>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
       
  
    </Card>

 {/* )} */}
 <Box display="flex" justifyContent="space-between"  flexWrap="wrap" gap={0.5} p={1}
      sx={{
      position: 'sticky',
      bottom: 0,
      zIndex: 10,
      backgroundColor: 'white',
      // padding: 2,
      boxShadow: '0 -2px 8px rgba(0,0,0,0.05)',
      mt: 'auto'
    }}>


<Box display="flex" justifyContent="flex-end" width="100%"  padding={1}>
          <Box width="200px" ml="auto">
            <Grid container spacing={1}>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Grid container spacing={2}>
                  <Grid item lg={6} md={6} sm={6} xs={6} textAlign="right">
                    <Typography sx={{ whiteSpace: "nowrap" }}>
                      Sub Total:
                    </Typography>
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={6} textAlign="right">
                    <Typography>
                    {subTotal.toFixed(2)}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              {/* Discount (if applicable) */}
              {totalDiscount?

<>
{discounts.map((discount, index) => (
  <Grid item lg={12} md={12} sm={12} xs={12} key={index}>
    <Grid container spacing={2}>
      <Grid item lg={6} md={6} sm={6} xs={6} textAlign="right">
        <Typography sx={{ whiteSpace: "nowrap" }}>
          {discount.description || "Discount"}:
        </Typography>
      </Grid>
      <Grid item lg={6} md={6} sm={6} xs={6} textAlign="right">
        <Typography>
          {Number(discount.value).toFixed(2)}
        </Typography>
      </Grid>
    </Grid>
  </Grid>
))}
             
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Grid container spacing={2}>
                              <Grid item lg={6} md={6} sm={6} xs={6} textAlign="right">
                                <Typography sx={{ whiteSpace: "nowrap" }}>
                                  Total Discount:
                                </Typography>
                              </Grid>
                              <Grid item lg={6} md={6} sm={6} xs={6} textAlign="right">
                                <Typography>
                                  {totalDiscount.toFixed(2)}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Grid></>
              :null}

              {/* HST */}
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Grid container spacing={2}>
                  <Grid item lg={6} md={6} sm={6} xs={6} textAlign="right">
                    <Typography sx={{ whiteSpace: "nowrap" }}>HST:</Typography>
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={6} textAlign="right">
                  <Typography>
                    {hstAmount.toFixed(2)}
                 </Typography>
                  </Grid>
                </Grid>
              </Grid>

              {/* Grand Total */}
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Grid container spacing={2}>
                  <Grid item lg={6} md={6} sm={6} xs={6} textAlign="right">
                    <Typography sx={{ whiteSpace: "nowrap", fontWeight: "bold" }}>
                      Grand Total:
                    </Typography>
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={6} textAlign="right">
                    <Typography style={{ fontWeight: "bold" }}>
                    {/* {(
      cartItems.reduce((acc, item) => {
        const price = item.salePrice > 0 ? item.salePrice : item.regularPrice;
        return acc + price * item.quantity;
      }, 0) * 1.13 // Apply 13% tax
    ).toFixed(2)} */}
    {grandTotal.toFixed(2)}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

            </Grid>
          </Box>
        </Box>


<Grid item xs={12}>
  <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 0.6 }}>

  <Button
    size="small"
  //  className={classes.SalesAddButton}
    variant="contained"
    sx={{
      flex: "1 1 18%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: '#058292 !important',
      textTransform: "none",
      paddingTop: '5px !important',
      paddingBottom: '5px !important',
      boxShadow:'none',
    }}
    onClick={handleShowCashForm} 
  >
    <MoneyIcon fontSize="medium" />
    <Typography variant="body2" fontWeight="bold" >Cash</Typography>
  </Button>

  <Button
    size="small"
   // className={classes.SalesAddButton}
    variant="contained"
    sx={{
      flex: "1 1 18%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: '#058292 !important',
      textTransform: "none",
      paddingTop: '5px !important',
      paddingBottom: '5px !important',
      boxShadow:'none',
    }}
    onClick={() => handleSaveInvoice("Credit")}
     disabled={actionLoading === "Credit"}
  >
     
    <CreditCardIcon fontSize="medium" />
    <Typography variant="body2" fontWeight="bold">
    {actionLoading === "Credit"? <CircularProgress size={20} /> : " Credit"}
    </Typography>
  </Button>

  <Button
    size="small"
   // className={classes.SalesAddButton}
    variant="contained"
    sx={{
      flex: "1 1 18%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: '#058292 !important',
      textTransform: "none",
      paddingTop: '2px !important',
      paddingBottom: '2px !important',
      boxShadow:'none',
    }}
    onClick={() => handleSaveInvoice("Debit")}
     disabled={actionLoading === "Debit"}
  >
    <PaymentIcon fontSize="medium" />
    <Typography variant="body2" fontWeight="bold">
  
      {actionLoading === "Debit" ? <CircularProgress size={20} /> : "   Debit"}
    </Typography>
  </Button>

  <Button
    size="small"
   // className={classes.SalesAddButton}
    variant="contained"
    sx={{
      flex: "1 1 18%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: '#058292 !important',
      textTransform: "none",
      paddingTop: '5px !important',
      paddingBottom: '5px !important',
      boxShadow:'none',
    }}
    onClick={handleShowSplitForm} 
  >
    <AccountBalanceWalletIcon fontSize="medium" />
    <Typography variant="body2" fontWeight="bold">Split</Typography>
  </Button>

  <Button
    size="small"
 //   className={classes.SalesAddButton}
    variant="contained"
    sx={{
      flex: "1 1 18%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: '#f2601f !important',
      textTransform: "none",
      paddingTop: '2px !important',
      paddingBottom: '2px !important',
      boxShadow:'none',
    }}
    onClick={handleShowDiscountForm} 
  >
    <PercentIcon fontSize="medium" />
    <Typography variant="body2" fontWeight="bold">Discount</Typography>
  </Button>
  </Box>
</Grid>


</Box>

  </Grid>



  
      </Grid>


      
    

    <Dialog open={openD} onClose={handleCloseDialog}>
                <Grid className={classes.Dialog}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 2, padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      pt={2}
                      alignContent={"center"}
                    >
                      <Typography className={classes.cardTitle}>
                        Confirm Action
                      </Typography>
                    </Grid>
                  </Grid>
                  <DialogContent>
                    <DialogContentText sx={{ pt: 3 }}>
                      Are you sure you want to proceed with invoice success?
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions sx={{ paddingRight: "24px", p: 4, py: 3, gap: 2 }}>
                    <Grid container spacing={3}>
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        sx={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <Button
                          variant="contained"
                          startIcon={<CheckCircleOutlineSharpIcon />}
                          className={classes.addButton}
                          onClick={handleConfirmDialog}
                        >
                          Yes
                        </Button>
                      </Grid>
                    </Grid>
                  </DialogActions>
                </Grid>
              </Dialog>


<Dialog open={Boolean(selectedProduct && variants.length > 0)} onClose={() => setSelectedProduct(null)}>
  <DialogTitle>Select Variant for {selectedProduct?.productName}</DialogTitle>
  <DialogContent>
    {variants.map((variant) => (
      <Button
        key={variant.id || variant.variantName} 
        fullWidth
        sx={{ mb: 1 }}
        onClick={() => {
         handleAddToCart({
  id: Number(selectedProduct!.id),           
  productName: selectedProduct!.productName,
  productPrice: parseFloat(variant.price) || Number(selectedProduct!.productPrice) || 0,
  salePrice: Number(selectedProduct!.salePrice) || 0,
  quantity: 1,                                 
  variantName: variant.variantName,
  variantPrice: parseFloat(variant.price) || 0,
    type: 'variant',
});

          setSelectedProduct(null);
          setVariants([]);
          setProductId("");
        }}
      >
        {variant.variantName} - ${variant.price}
      </Button>
    ))}
  </DialogContent>
</Dialog>

<Dialog
  open={expandedModifiers.open}
  onClose={() => setExpandedModifiers({ open: false, product: null })}
  fullWidth
  maxWidth="sm"
>
  <DialogTitle sx={{ fontWeight: 600, fontSize: "15px" }}>
    Options for {expandedModifiers.product?.productName}
  </DialogTitle>

  <DialogContent dividers>
    {expandedModifiers.product?.modifierGroupId
     ?.slice() // create a copy
  .sort((a: any, b: any) => (a.order ?? 0) - (b.order ?? 0)) .map(
      (group: any, index: number) => {
        // Find modifier group name from modifierGrpList
        const groupInfo = modifierGrpList.find(
          (g: any) => g.id === group.id
        );
        const groupName = groupInfo?.modifierGroupName || `Modifier Group #${group.id}`;

        return (
          <Box
            key={index}
            mb={2}
            pb={2}
            borderBottom={
              index !== expandedModifiers.product?.modifierGroupId.length - 1
                ? "1px solid #e0e0e0"
                : "none"
            }
          >
            {/* GROUP NAME */}
             <Typography variant="h6" sx={{ fontWeight: 600, display: 'flex', alignItems: 'center', gap: 0.5 }}>
              {groupName}
              {group.minimum > 0 && (
                <span style={{ color: "red" }}>*</span>
              )}
            </Typography>

            {/* MIN / MAX DESCRIPTION */}
            <Typography variant="body2" sx={{ mb: 1 }}>
              {group.minimum === 0 && group.maximum > 0
                ? `Select up to ${group.maximum} option${group.maximum > 1 ? "s" : ""}`
                : group.minimum === group.maximum
                ? `Please select ${group.minimum} option${group.minimum > 1 ? "s" : ""}`
                : `Please select between ${group.minimum} and ${group.maximum} options`}
            </Typography>

            {/* MODIFIERS LIST */}
            <Box display="flex" flexWrap="wrap" gap={1}>
              {group.modifiers.filter((mod: any) => mod.pos).map((mod: any, idx: number) => {
                const modKey = mod.product_id + "-" + idx;
                const isSelected = selectedModifiers[group.id]?.includes(modKey);

                // Get product name from productList
             const productInfo = productList.find((p: any) => Number(p.id) === Number(mod.product_id));
                const productName = productInfo?.productName || `Product ${mod.product_id}`;

                return (
                  <Chip
                    key={idx}
                    clickable
                    label={productName + (mod.price > 0 ? ` + $${mod.price}` : "")}
                    variant={isSelected ? "filled" : "outlined"}
                    color="primary"
                    sx={{ fontSize: "14px", cursor: "pointer" }}
                    onClick={() => {
                      handleAddToCart({
                        id: modKey,
                        productName: productName,
                        productPrice: 0,
                        salePrice: mod.price || 0,
                        quantity: 1,
                        type: "modifier",
                      });

                      setSelectedModifiers((prev: any) => {
                        const current = prev[group.id] || [];
                        const alreadySelected = current.includes(modKey);

                        return {
                          ...prev,
                          [group.id]: alreadySelected
                            ? current.filter((id: string) => id !== modKey)
                            : [...current, modKey],
                        };
                      });
                    }}
                  />
                );
              })}
            </Box>
          </Box>
        );
      }
    )}
  </DialogContent>
</Dialog>



{/* <Dialog
  open={expandedModifiers.open}
  onClose={() => setExpandedModifiers({ open: false, product: null })}
  fullWidth
  maxWidth="sm"
>
  <DialogTitle sx={{ fontWeight: 600, fontSize: '15px' }}>
    Options for {expandedModifiers.product?.productName}
  </DialogTitle>

  <DialogContent dividers>
    {expandedModifiers.product?.modifierGroups.map((group: any, index: number) => (
      <Box
        key={index}
        mb={2}
        pb={2}
        borderBottom={index !== expandedModifiers.product?.modifierGroups.length - 1 ? '1px solid #e0e0e0' : 'none'}
      >
      <Typography variant="h6" sx={{ fontWeight: 600, display: 'flex', alignItems: 'center', gap: 0.5 }}>
          {group.groupName}
          {group.required && (
            <span style={{ color: 'red', marginLeft: 4 }}>*</span>
          )}
        </Typography> */}
      {/* <Typography variant="body2"  sx={{ mb: 1, }}>
  {group.minimum === 0 && group.maximum > 0
    ? `Select up to ${group.maximum} option${group.maximum > 1 ? 's' : ''}`
    : group.minimum === group.maximum
      ? `Please select ${group.minimum} option${group.minimum > 1 ? 's' : ''}`
      : `Please select between ${group.minimum} and ${group.maximum} options`}
</Typography> */}

        {/* <Box
          display="flex"
          flexWrap="wrap"
          gap={1}
          mt={1}
        >
{group.modifiers.map((mod: any, idx: number) => {
  const modifierKey = mod.modifierId || mod.id || idx;
  const isSelected = selectedModifiers[group.groupName]?.includes(modifierKey);

  return (
    <Chip
      key={idx}
      clickable
      label={
        mod.modifierPrice > 0
          ? `${mod.modifierName} + $${mod.modifierPrice.toFixed(2)}`
          : mod.modifierName
      }
      variant={isSelected ? "filled" : "outlined"}
      color={isSelected ? "primary" : "primary"}
      sx={{ fontSize: '14px', cursor: 'pointer' }}
      onClick={() => {
        handleAddToCart({
          id: modifierKey,
          productName: mod.modifierName,
          productPrice: mod.modifierPrice || 0,
          salePrice: 0,
          quantity: 1,
          type: 'modifier',
        });

        setSelectedModifiers((prev) => {
          const groupName = group.groupName;
          const current = prev[groupName] || [];
          const alreadySelected = current.includes(modifierKey);

          return {
            ...prev,
            [groupName]: alreadySelected
              ? current.filter((id) => id !== modifierKey)
              : [...current, modifierKey],
          };
        });
      }}
    />
  );
})}



        </Box>
      </Box>
    ))}
  </DialogContent>
</Dialog> */}

<Dialog
  open={expandedLinks.open}
  onClose={() => setExpandedLinks({ open: false, product: null })}
  fullWidth
  maxWidth="sm"
>
  <DialogTitle sx={{ fontWeight: 600, fontSize: '15px' }}>
    Linked Products for {expandedLinks.product?.productName}
  </DialogTitle>

 <DialogContent dividers>
    {expandedLinks.product?.linkedProductId ? (
      JSON.parse(expandedLinks.product.linkedProductId).map((linkedId: number) => {
        const linkedProduct = productList.find(p => p.id === linkedId);
        if (!linkedProduct) return null;

        return (
          <Box
            key={linkedProduct.id}
            sx={{
              display: 'flex',
              alignItems: 'center',
              padding: '8px',
              borderBottom: '1px solid #eee',
              cursor: 'pointer'
            }}
            onClick={() => {
               const categoryIndex = categoryList.findIndex(
    (cat) => cat.id === linkedProduct.productCategoryId
  );

  if (categoryIndex !== -1) {
    handleChangeCategory(categoryIndex); 
  }
              setExpandedLinks({ open: false, product: null });
            }}
          >
            <img
              src={`${LARAVEL_API_URL}/${linkedProduct.productImg}`}
              alt={linkedProduct.productName}
              style={{ width: 50, height: 50, objectFit: 'contain', marginRight: 12 }}
            />
            <Box>
              <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                {linkedProduct.productName}
              </Typography>
              {/* <Typography variant="body2" sx={{ color: '#f2601f' }}>
                ${linkedProduct.salePrice || linkedProduct.productPrice}
              </Typography> */}
            </Box>
          </Box>
        );
      })
    ) : (
      <Typography variant="body2">No linked products available</Typography>
    )}
  </DialogContent>
</Dialog>


<Dialog open={showSerialPopup} onClose={() => setShowSerialPopup(false)} maxWidth="md" fullWidth>
      <DialogTitle>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>Serialized Product Details</Grid>
          <Grid item>
            <TextField
              size="small"
              placeholder="Search Serial / Model No"
              value={searchTextSerialized}
              onChange={(e) => setSearchTextSerialized(e.target.value)}
            />
          </Grid>
        </Grid>
      </DialogTitle>

  <DialogContent dividers>
    {availableSerials && availableSerials.length > 0 ? (
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell><strong>Serial No</strong></TableCell>
            <TableCell><strong>Model No</strong></TableCell>
              <TableCell><strong>Vendor</strong></TableCell>
            <TableCell><strong>Buy Price</strong></TableCell>
            <TableCell><strong>Date</strong></TableCell>
            <TableCell align="center"><strong>Action</strong></TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {availableSerials.map((serial) => {
 const list = Array.isArray(serial.bill?.quoteWorkOrderSale)
    ? serial.bill?.quoteWorkOrderSale || []
    : JSON.parse(serial.bill?.quoteWorkOrderSale || "[]");

  // const saleItem =
  //   list.find((sale: any) => sale.productName === serial.productName) || null;

    const saleItem =
  list.find((sale: any) => sale.productId === serial.productId) || null;


     return (
              <TableRow key={serial.id}>
                <TableCell>{serial.SERIALNO}</TableCell>
                <TableCell>{serial.modelNo}</TableCell>
          <TableCell> {serial.bill?.customer
              ? `${serial.bill.customer.customerFirstName} ${serial.bill.customer.customerLastName}`
              : '-'}</TableCell>  
                <TableCell>{saleItem?.price ?? '-'}</TableCell>
                <TableCell>{serial.bill?.quoteWorkOrderIssueDate ? new Date(serial.bill.quoteWorkOrderIssueDate).toLocaleDateString() : '-'}</TableCell>
                <TableCell align="center">
                  <Button
                    variant="contained"
                    size="small"
                

                    onClick={() => {
                      handleAddToCart({
                        ...serial,
                        type: "serialized",
                          id: saleItem.productId, 
                        productName: saleItem.productName, 
                        productPrice: saleItem?.buyingPrice ?? 0,
                        salePrice: saleItem.sellingPrice ?? 0,
                        sellingPrice: saleItem.sellingPrice ?? 0,
                        buyingPrice: saleItem.buyingPrice ?? 0,
                      vendorId: saleItem.vendorId ?? null,
                      SERIALNO: serial.SERIALNO ?? null, // serial number
      modelNo: serial.modelNo ?? null,    // model number
      IMEI: serial.IMEInO ?? null, 
                      });
                      setShowSerialPopup(false);
                    }}
                  >
                    ADD
                </Button>
              </TableCell>
            </TableRow>
  );
  })}
        </TableBody>
      </Table>
    ) : (
      <p>No serialized items found.</p>
    )}
  </DialogContent>
</Dialog>
<Dialog
  open={openWeightModal}
  onClose={() => setOpenWeightModal(false)}
  maxWidth="xs"
  fullWidth
>
  <DialogTitle>Enter Weight (grams)</DialogTitle>

  <DialogContent>
    <TextField
      type="number"
      fullWidth
      margin="dense"
      label="Weight in grams"
      value={weightInput}
      onChange={(e) => setWeightInput(e.target.value)}
    />
  </DialogContent>

  <DialogActions sx={{ paddingRight: "24px", p: 3, py: 3, gap: 2 }}>
   <Grid container spacing={3}>
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        sx={{ display: "flex", justifyContent: "flex-end" }}
                      >
    {/* <Button
      onClick={() => setOpenWeightModal(false)}

      variant="outlined"
    >
      Cancel
    </Button> */}

    <Button
      onClick={handleWeightConfirm}
      variant="contained"
    >
      Add
    </Button>
    </Grid>
    </Grid>
  </DialogActions>
</Dialog>




{openGameModal && (
  <GameSlotModal
    product={gameProduct}
    onClose={() => setOpenGameModal(false)}
    onConfirm={(slotSelection: ISlotSelection) => {
      if (gameProduct) {
        
        handleAddToCart({
          ...gameProduct,
          ...slotSelection,
          type: "product",
        });
      }
      setOpenGameModal(false);
    }}
  />
)}


      </>
  

  );
};

export default Index;
